import React, { useState, useCallback, useEffect, useRef } from "react";
import useDarkMode from '../../hooks/useDarkMode';
import useThemeColor from "../../hooks/useThemeColor";
import { useSelector, useDispatch } from "react-redux";
import { updateUserData } from "../../app/auth/authSlice";
import { useNavigate, useParams, Link } from "react-router-dom";
import axiosInstance from "../../config/axiosApi/axiosApi";
import APIs from "../../Constants/apis";
import Preloader from "../../components/CustomComponents/preLoad/preLoader";
import { Panel, PanelBody, PanelHeader } from "../../components/panel/panel";
import showErrorToast, {
  showSuccessToast,
} from "../../components/CustomComponents/toast/toast";
import FormInput from "../../components/CustomComponents/Input/formInput";
import ToggleSwitch from "../../components/CustomComponents/Switchery/switchery";
import ImageUploadWithGallery from "../../components/CustomComponents/ImageUploadWithGallery/ImageUploadWithGallery";
import {
  toRelativeMediaPath,
  uploadCompanyMediaFile,
} from "../../utils/mediaImageUtils";
import { ChoiceButtonGrid } from "../../components/CustomComponents/Buttons/ChoiceButton/choiceButton";
import CategorySelector from "../../components/CustomComponents/modal/CategorySelector";
import ModifierGroupsSelector from "../../components/CustomComponents/modal/ModifierGroupsSelector";
import AllergenSelector from "../../components/CustomComponents/modal/AllergenSelector";
import MenuGroupsSelector from "../../components/CustomComponents/modal/MenuGroupsSelector";
import ProductMultiSelectionModal from "../../components/CustomComponents/modal/productMultiSelectionModel";
import CustomDateTimePicker from "../../components/DateTimePicker/dateTimePicker";
import DebugMUIDatePicker from "../../components/CustomComponents/MUIDatePicker/DebugMUIDatePicker";
import "../../components/CustomComponents/MUIDatePicker/MUIDatePicker.css";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import "../../components/DateTimePicker/dateTimePicker.css";
import "../../components/DateTimePicker/materialUIOverrides.css";
import moment from "moment";
import CustomModal from "../../components/CustomComponents/modal/customModal";
import ReportingCategoryModel from "../../components/CustomComponents/modal/reportingCategory";
import { Modifier } from "../modifiers/initializeModifier";
import BranchAssignmentSelector from "../../components/CustomComponents/BranchAssignment/BranchAssignmentSelector";

const CreateItem = () => {
  const { ProductType, IsCombo } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const CompID = useSelector((state) => state.auth.user)?.userData?.compID;
  const { profileData, settingsData } = useSelector((state) => state.auth);
  const hasProfileData = !!profileData;
  const hasSettingsData = !!settingsData;
  const profileCompCurrency = profileData?.compCurrency;
  const settingsVat = settingsData?.s_VAT;
  const settingsTaxEnabled = settingsData?.isTaxEnabled;
  const appSettings = useSelector((state) => state.appSettings);
  const { appTheme } = appSettings;
  const [compCurrency, setCompCurrency] = useState("GBP");

  // Get theme color from centralized hook
  const themeColor = useThemeColor();

  const [formState, setFormState] = useState({
    menuItem_Name: "",
    menuItem_KitchenDisplayName: "",
    menuItem_Detail: "",
    menuItem_RootType: ProductType || "",
    menuItem_ColorCode: "",
    menuItem_SalePrice: "0",
    menuItem_CostPrice: "0",
    menuItem_TaxPercentage: "0",
    menuItem_TakeAwayPrice: "0",
    menuItem_DeliveryPrice: "0",
    menuItem_ServingSize: "1",
    menuItem_PreparationTime: "",
    menuItem_SKU: "",
    menuItem_SEOTitle: "",
    menuItem_SEODescription: "",
    menuItem_Permalink: "",
    menuItem_ASTime: "",
    menuItem_AETime: "",
    menuItem_Rating: "",
    menuItem_BarCode: "",
    menuItem_Type: IsCombo ? "Combo" : "Product",
    menuItem_ImageAltText: "",
    retail_Markup: "0",
    delivery_Markup: "0",
    online_Markup: "0",
    current_Quantity: "0",
    reorder_Quantity: "0",
    reorder_Level: "0",
    availableQuantity: "0",
    orderQuantityLimit: "",
    menuItem_DefaultModifierTitle: "",
    brand_ID: "",
    ingredientID: "",
    parentMenuItemID: "",
    itsMasterProductID: "",
    reportCat_ID: "",
    stadardUnit: "",
    unitSize: "",
    mP_UnitOfSale: "",
    mP_VolumnOfSale: "",
    menuItem_Orderby: "",
    localizeID: "en",
    appMode: "testing",
    menuItem_MeasurementType: "Unit",
    menuItem_DefaultSize: "",
    menuItem_DefaultSizeUnit: "",
    menuItem_ContainerType: "",
    menuitem_DefaultSizeInBaseUnit: 0,
  });

  const [errors, setErrors] = useState({
    menuItem_Name: "",
    menuItem_SalePrice: "",
  });

  const [toggles, setToggles] = useState({
    menuItem_Publish: true,
    is_ShowInKiosk: true,
    isSellOnTill: true,
    isActiveMobileApp: true,
    is_OutOfStock: false,
    menuItem_IsSellingProduct: true,
    skuEnabled: false,
    expiryDateEnabled: false,
    seoEnabled: false,
    modifierGroupsEnabled: false,
    allergensEnabled: false,
    productsEnabled: IsCombo || false,
    menuItem_Homefeatured: false,
    menuItem_featured: false,
    menuItem_IsModifier: false,
    menuItem_IsFavorite: false,
    menuItem_HasVariant: false,
    isArchieve: false,
    isAllowedtoSetPriceatThePointofSale: false,
    isTaxExempt: false,
    isPreventGainingLoyalty: false,
    isHaveCustomerSpecificPricing: false,
    isProductisScannableOnly: false,
    isMasterProduct: false,
    itHasAMasterProduct: false,
    menuItem_IsDefaultModifier: false,
    isShowNotificationExpDate: false,
    isShowSocialMediaLink: false,
  });

  const [imageState, setImageState] = useState({
    menuItem_Image: "",
    imageFile: null,
  });

  const [selectors, setSelectors] = useState({
    selectedParentCategory: [],
    selectedModifierGroups: [],
    selectedAllergens: [],
    selectedMenuGroups: [],
    selectedProducts: [],
  });

  const [reportingCategory, setReportingCategory] = useState({});
  const [products, setProducts] = useState([]);
  const [allAllergens, setAllAllergens] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [settings, setSettings] = useState({ s_VAT: "", isTaxEnabled: false });
  const [units, setUnits] = useState([]);
  const [filteredUnits, setFilteredUnits] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [isParentBranch, setIsParentBranch] = useState(false);
  const [modals, setModals] = useState({
    showParentCategoryModal: false,
    showReportingCategoryModal: false,
    showModifierModal: false,
    showAllergenModal: false,
    showMenuGroupModal: false,
    isModalOpen: false,
    showProductModal: false,
    showBranchAssignmentModal: false,
  });

  // Modal management to prevent multiple modals open simultaneously
  const openModal = (modalName) => {
    // Close all other modals first
    setModals(prev => {
      const newModals = {};
      Object.keys(prev).forEach(key => {
        newModals[key] = key === modalName;
      });
      return newModals;
    });
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
    document.body.classList.add('modal-open');
  };

  const closeAllModals = () => {
    setModals(prev => {
      const newModals = {};
      Object.keys(prev).forEach(key => {
        newModals[key] = false;
      });
      return newModals;
    });
    // Restore body scroll when modal is closed
    document.body.style.overflow = 'unset';
    document.body.classList.remove('modal-open');
  };

  // Clean up body styles on unmount
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset';
      document.body.classList.remove('modal-open');
    };
  }, []);
  const [expiryDate, setExpiryDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const isDarkMode = useDarkMode();

  const dragItem = useRef(null);
  const dragOverItem = useRef(null);
  const prevMeasurementTypeRef = useRef(null);

  const currencySymbols = {
    GBP: "£",
    USD: "$",
    EUR: "€",
  };

  const getCurrencySymbol = (currencyCode) => {
    return currencySymbols[currencyCode] || currencyCode;
  };

  const fetchCompCurrency = useCallback(async () => {
    try {
      // First, try to get from Redux state
      if (hasProfileData) {
        setCompCurrency(profileCompCurrency || "GBP");
        return;
      }

      // If not in Redux, try to fetch from API
      try {
        const response = await axiosInstance.get(APIs.GET_COMPANY_PROFILE);
        if (response.data?.data) {
          const currency = response.data.data.compCurrency || "GBP";
          setCompCurrency(currency);
          // Update Redux with fetched data
          dispatch(updateUserData({ profileData: response.data.data }));
          return;
        }
      } catch (apiErr) {
        console.error("Failed to fetch profile from API:", apiErr);
      }

      // If both fail, use default but don't show error toast on initial load
      setCompCurrency("GBP");
    } catch (err) {
      console.error("Error in fetchCompCurrency:", err);
      setCompCurrency("GBP"); // Use default instead of showing error
    }
  }, [hasProfileData, profileCompCurrency, dispatch]);

  const fetchSettings = useCallback(async () => {
    try {
      setLoading(true);
      
      // First, try to get from Redux state
      if (hasSettingsData) {
        const newSettings = {
          s_VAT: settingsVat || 0,
          isTaxEnabled: settingsTaxEnabled ?? false,
        };
        setSettings(newSettings);
        setLoading(false);
        return;
      }

      // If not in Redux, try to fetch from API
      try {
        const response = await axiosInstance.get(APIs.GET_COMPANY_SETTINGS);
        if (response.data?.data) {
          const newSettings = {
            s_VAT: response.data.data.s_VAT || 0,
            isTaxEnabled: response.data.data.isTaxEnabled ?? false,
          };
          setSettings(newSettings);
          // Update Redux with fetched data
          dispatch(updateUserData({ settingsData: response.data.data }));
          setLoading(false);
          return;
        }
      } catch (apiErr) {
        console.error("Failed to fetch settings from API:", apiErr);
      }

      // If both fail, use defaults but don't show error toast on initial load
      const defaultSettings = {
        s_VAT: 0,
        isTaxEnabled: false,
      };
      setSettings(defaultSettings);
    } catch (err) {
      console.error("Error in fetchSettings:", err);
      // Use defaults instead of showing error
      setSettings({
        s_VAT: 0,
        isTaxEnabled: false,
      });
    } finally {
      setLoading(false);
    }
  }, [hasSettingsData, settingsVat, settingsTaxEnabled, dispatch]);

  const fetchAllergens = useCallback(async () => {
    try {
      const response = await axiosInstance.get(
        "/api/Allergen/GetAllAllergensGlobal"
      );
      setAllAllergens(response.data.data || []);
    } catch (err) {
      console.error("Error fetching allergens:", err);
      setAllAllergens([]);
      showErrorToast("Failed to fetch allergens");
    }
  }, []);

  // Fetch products for combo selection - use same API as Purchase Order to get variants with their titles
  const fetchProducts = useCallback(async () => {
    if (!CompID) return;
    try {
      setLoading(true);
      const response = await axiosInstance.get(APIs.GET_ALL_PRODUCTS_FOR_PURCHASE_ORDER, {
        params: { CompID },
      });
      setProducts(response.data.data || response.data);
    } catch (err) {
      setProducts([]);
      showErrorToast("Failed to fetch products");
    } finally {
      setLoading(false);
    }
  }, [CompID]);

  const fetchAllCategories = useCallback(async () => {
    if (!CompID) return;
    try {
      const response = await axiosInstance.get(APIs.GET_CATEGORIES, {
        params: {
          CompID,
          SortBy: "RootCat_Name",
          SortOrder: "ASC",
          Search: "",
        },
      });
      const categoryData = response.data.data || response.data;
      if (Array.isArray(categoryData)) {
        // Flatten categories including subcategories
        const flattenCategories = (categories) => {
          let result = [];
          categories.forEach(cat => {
            if (cat && !cat.isAddOnCategory) {
              result.push(cat);
              if (cat.subCategoriesList && cat.subCategoriesList.length > 0) {
                result = result.concat(flattenCategories(cat.subCategoriesList));
              }
            }
          });
          return result;
        };
        setAllCategories(flattenCategories(categoryData));
      } else {
        setAllCategories([]);
      }
    } catch (err) {
      setAllCategories([]);
      showErrorToast("Failed to fetch categories");
    }
  }, [CompID]);

  const fetchUnits = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/Unit/SuperAdmin/GetAllUnits", {
        params: {
          SortBy: "MeasureName",
          SortOrder: "ASC",
          Search: "",
          PageSize: "1000",
          PageNumber: 1,
        },
      });

      if (response.data.status) {
        const unitsData = response.data.data || [];
        setUnits(Array.isArray(unitsData) ? unitsData : []);
      } else {
        console.error("Failed to fetch units:", response.data.Message);
        setUnits([]);
      }
    } catch (err) {
      console.error("Error fetching units:", err);
      setUnits([]);
    }
  }, []);

  useEffect(() => {
    const handler = setTimeout(async () => {
      await Promise.all([
        fetchSettings(),
        fetchCompCurrency(),
        fetchAllergens(),
        fetchAllCategories(),
        fetchUnits(),
        toggles.productsEnabled ? fetchProducts() : Promise.resolve(),
      ]);
    }, 500);
    return () => clearTimeout(handler);
  }, [
    fetchSettings,
    fetchCompCurrency,
    fetchAllergens,
    fetchAllCategories,
    fetchUnits,
    fetchProducts,
    toggles.productsEnabled,
  ]);

  // Check if company has branches (only show branch UI if branches exist); auto pre-select all branches for new product
  useEffect(() => {
    const checkParentBranch = async () => {
      if (!CompID) return;
      try {
        const response = await axiosInstance.get(APIs.GET_COMPANY_LOCATIONS, {
          params: { CompID },
        });
        const branches = response.data?.data || [];
        // Normalize types/casing because APIs may return string IDs or camelCase fields.
        const toInt = (v) => {
          if (v === null || v === undefined) return null;
          const n = typeof v === "number" ? v : parseInt(v, 10);
          return Number.isFinite(n) ? n : null;
        };
        const compIdInt = toInt(CompID);
        const childBranches = Array.isArray(branches)
          ? branches.filter((b) => {
              const parentComId = toInt(b?.ParentComID ?? b?.parentComID);
              const branchCompId = toInt(b?.CompID ?? b?.compID);
              return parentComId !== null
                && compIdInt !== null
                && parentComId === compIdInt
                && branchCompId !== compIdInt;
            })
          : [];
        const hasChildBranches = childBranches.length > 0;
        setIsParentBranch(hasChildBranches);
        if (hasChildBranches) {
          setSelectedBranches(childBranches);
        }
      } catch (err) {
        setIsParentBranch(false);
      }
    };
    checkParentBranch();
  }, [CompID]);



  useEffect(() => {
    if (
      !toggles.isTaxExempt &&
      settings.isTaxEnabled &&
      settings.s_VAT &&
      (!formState.menuItem_TaxPercentage ||
        formState.menuItem_TaxPercentage === "" ||
        formState.menuItem_TaxPercentage === "0")
    ) {
      setFormState((prev) => ({
        ...prev,
        menuItem_TaxPercentage: settings.s_VAT.toString(),
      }));
    } else if (toggles.isTaxExempt) {
      setFormState((prev) => ({
        ...prev,
        menuItem_TaxPercentage: "",
      }));
    }
  }, [toggles.isTaxExempt, settings.s_VAT, settings.isTaxEnabled]);


  // Auto-derive reporting category from selected categories
  // Set to first category if no reporting category is set, or if the current one is not in the list
  useEffect(() => {
    if (selectors.selectedParentCategory.length > 0) {
      // Check if current reporting category is still in the selected categories
      const isReportingCategoryInList = reportingCategory && (
        reportingCategory.rootCat_ID || reportingCategory.rC_ID
      ) && selectors.selectedParentCategory.some(cat =>
        (cat.rootCat_ID && cat.rootCat_ID === (reportingCategory.rootCat_ID || reportingCategory.rC_ID)) ||
        (cat.rC_ID && cat.rC_ID === (reportingCategory.rootCat_ID || reportingCategory.rC_ID))
      );

      // Only auto-set if no reporting category is set, or if current one is not in the list
      if (!reportingCategory || !reportingCategory.rootCat_ID && !reportingCategory.rC_ID || !isReportingCategoryInList) {
        const firstCategory = selectors.selectedParentCategory[0];
        setReportingCategory(firstCategory);
      }
    } else {
      setReportingCategory({});
    }
  }, [selectors.selectedParentCategory]);

  // Auto-enable/disable modifierGroupsEnabled based on selection
  useEffect(() => {
    const modifierGroupsLength = Array.isArray(selectors.selectedModifierGroups)
      ? selectors.selectedModifierGroups.length
      : 0;
    const hasModifierGroups = modifierGroupsLength > 0;

    setToggles((prev) => {
      // Only update if the value actually changed to avoid unnecessary re-renders
      if (prev.modifierGroupsEnabled !== hasModifierGroups) {
        return {
          ...prev,
          modifierGroupsEnabled: hasModifierGroups,
        };
      }
      return prev;
    });
  }, [selectors.selectedModifierGroups]);

  // Auto-enable/disable allergensEnabled based on selection
  useEffect(() => {
    setToggles((prev) => ({
      ...prev,
      allergensEnabled: selectors.selectedAllergens.length > 0,
    }));
  }, [selectors.selectedAllergens]);

  // Filter units based on selected measurement type
  useEffect(() => {
    if (formState.menuItem_MeasurementType && units.length > 0) {
      const filtered = units.filter(
        (unit) => (unit.MeasurementTypeName || unit.measurementTypeName) === formState.menuItem_MeasurementType
      );
      setFilteredUnits(filtered);
      console.log("Filtered units for", formState.menuItem_MeasurementType, ":", filtered);
    } else {
      setFilteredUnits([]);
    }
  }, [formState.menuItem_MeasurementType, units]);

  // Calculate DefaultSizeInBaseUnit when measurement type, default size, or unit changes
  useEffect(() => {
    if (formState.menuItem_MeasurementType === "Unit") {
      // For Unit type, set to 0
      setFormState((prev) => ({
        ...prev,
        menuitem_DefaultSizeInBaseUnit: 0,
      }));
    } else if (
      formState.menuItem_MeasurementType &&
      (formState.menuItem_MeasurementType === "Weight" || formState.menuItem_MeasurementType === "Volume") &&
      formState.menuItem_DefaultSize &&
      formState.menuItem_DefaultSizeUnit &&
      units.length > 0
    ) {
      // Find the selected unit
      const selectedUnit = units.find(
        (unit) =>
          (unit.MeasureName || unit.measureName || unit.unitName || unit.name) === formState.menuItem_DefaultSizeUnit &&
          (unit.MeasurementTypeName || unit.measurementTypeName) === formState.menuItem_MeasurementType
      );

      if (selectedUnit) {
        const measurementValue = selectedUnit.Measurement || selectedUnit.measurement || selectedUnit.conversionValue || 1;
        const defaultSize = parseFloat(formState.menuItem_DefaultSize) || 0;
        const calculatedValue = defaultSize * measurementValue;

        setFormState((prev) => ({
          ...prev,
          menuitem_DefaultSizeInBaseUnit: calculatedValue,
        }));
      } else {
        // Unit not found, set to 0
        setFormState((prev) => ({
          ...prev,
          menuitem_DefaultSizeInBaseUnit: 0,
        }));
      }
    } else {
      // Reset to 0 if conditions not met
      setFormState((prev) => ({
        ...prev,
        menuitem_DefaultSizeInBaseUnit: 0,
      }));
    }
  }, [
    formState.menuItem_MeasurementType,
    formState.menuItem_DefaultSize,
    formState.menuItem_DefaultSizeUnit,
    units,
  ]);

  // When shared measurement type changes, clear per-variant unit/base (no inherit)
  useEffect(() => {
    const nextType = formState.menuItem_MeasurementType;
    const prevType = prevMeasurementTypeRef.current;
    if (prevType === null) {
      prevMeasurementTypeRef.current = nextType;
      return;
    }
    if (prevType === nextType) return;
    prevMeasurementTypeRef.current = nextType;

    if (!toggles.menuItem_HasVariant) return;
    setVariants((prev) =>
      (prev || []).map((v) => ({
        ...v,
        menuItem_MeasurementType: nextType || "",
        menuItem_DefaultSizeUnit: "",
        menuitem_DefaultSizeInBaseUnit: 0,
        ...(nextType === "Unit" ? { menuItem_DefaultSize: "" } : {}),
      }))
    );
  }, [formState.menuItem_MeasurementType, toggles.menuItem_HasVariant]);

  // Update Modifier with reportCat_ID and menuItem_TaxPercentage
  useEffect(() => {
    Modifier.menuItem_TaxPercentage =
      !toggles.isTaxExempt && settings.isTaxEnabled && settings.s_VAT
        ? settings.s_VAT.toString()
        : "";
    Modifier.reportCat_ID =
      reportingCategory?.rootCat_ID || reportingCategory?.rC_ID
        ? parseInt(reportingCategory.rootCat_ID || reportingCategory.rC_ID)
        : 0;
  }, [
    toggles.isTaxExempt,
    settings.isTaxEnabled,
    settings.s_VAT,
    reportingCategory,
  ]);

  const [variants, setVariants] = useState([
    {
      ...Modifier,
      current_Quantity: 0,
      reorder_Quantity: 0,
      reorder_Level: 0,
      menuItem_SellingMethodBoth: false,
      menuItem_TaxPercentage:
        !toggles.isTaxExempt && settings.isTaxEnabled && settings.s_VAT
          ? settings.s_VAT.toString()
          : "",
      reportCat_ID:
        reportingCategory?.rootCat_ID || reportingCategory?.rC_ID
          ? parseInt(reportingCategory.rootCat_ID || reportingCategory.rC_ID)
          : 0,
    },
  ]);

  // Update variants when reportingCategory or settings change
  useEffect(() => {
    setVariants((prevVariants) =>
      prevVariants.map((variant) => ({
        ...variant,
        reportCat_ID:
          reportingCategory?.rootCat_ID || reportingCategory?.rC_ID
            ? parseInt(reportingCategory.rootCat_ID || reportingCategory.rC_ID)
            : 0,
        menuItem_TaxPercentage:
          !toggles.isTaxExempt && settings.isTaxEnabled && settings.s_VAT
            ? settings.s_VAT.toString()
            : variant.menuItem_TaxPercentage,
      }))
    );
  }, [
    reportingCategory,
    toggles.isTaxExempt,
    settings.isTaxEnabled,
    settings.s_VAT,
  ]);

  const handleInputChange = (field) => (e) => {
    let value = e.target.value;

    // Clear "0" when user starts typing in numeric fields (price fields allow 0)
    const numericFields = [
      "menuItem_TaxPercentage",
      "current_Quantity",
      "reorder_Quantity",
      "reorder_Level"
    ];

    if (numericFields.includes(field) && value === "0") {
      value = "";
    }

    setFormState((prev) => ({ ...prev, [field]: value }));

    if (field === "menuItem_Name") {
      setErrors((prev) => ({
        ...prev,
        menuItem_Name: value.trim() ? "" : "Item Name is required",
      }));
      // Also update Kitchen Display Name when Item Name changes
      setFormState((prev) => ({ ...prev, menuItem_KitchenDisplayName: value }));
    }

    if (field === "menuItem_PreparationTime" && value && !/^\d+$/.test(value)) {
      showErrorToast("Preparation Time must be a positive number (e.g., 40)");
      return;
    }

    if (field === "menuItem_ServingSize" && value && !/^\d+$/.test(value)) {
      showErrorToast("Serving Size must be a positive number (e.g., 1)");
      return;
    }

    if (field === "menuItem_TaxPercentage" && !toggles.isTaxExempt) {
      if (value && !/^\d*\.?\d*$/.test(value)) {
        showErrorToast("Tax Percentage must be a valid number (e.g., 20)");
        return;
      }

      setFormState((prev) => ({
        ...prev,
        menuItem_TaxPercentage: value,
      }));
    }

    if (field === "menuItem_SalePrice" && value) {
      if (!/^\d*\.?\d*$/.test(value)) {
        showErrorToast("Sale Price must be a valid number (e.g., 100)");
        return;
      }
    }
  };

  const parseItemPrice = (value) => {
    if (value == null || String(value).trim() === "") return 0;
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? NaN : parsed;
  };

  // Helper function to display value or empty string if "0" or "0.00"
  const getDisplayValue = (value) => {
    if (!value || value === "0" || value === "0.00" || parseFloat(value) === 0) {
      return "";
    }
    return value;
  };

  const calculateDefaultSizeInBaseUnit = (measurementType, defaultSize, defaultSizeUnit) => {
    if (measurementType !== "Weight" && measurementType !== "Volume") return 0;
    if (!defaultSize || !defaultSizeUnit || units.length === 0) return 0;
    const selectedUnit = units.find(
      (unit) =>
        (unit.MeasureName || unit.measureName || unit.unitName || unit.name) === defaultSizeUnit &&
        (unit.MeasurementTypeName || unit.measurementTypeName) === measurementType
    );
    if (!selectedUnit) return 0;
    const measurementValue =
      selectedUnit.Measurement || selectedUnit.measurement || selectedUnit.conversionValue || 1;
    const size = parseFloat(defaultSize) || 0;
    return size * measurementValue;
  };

  const handleProductQuantityChange = (productId, value) => {
    if (value && !/^\d+$/.test(value)) {
      showErrorToast("Item Quantity must be a positive number");
      return;
    }
    if (parseInt(value) <= 0) {
      showErrorToast("Item Quantity must be greater than 0");
      return;
    }

    setSelectors((prev) => ({
      ...prev,
      selectedProducts: prev.selectedProducts.map((product) =>
        product.menuItem_ID === productId
          ? { ...product, availableQuantity: value }
          : product
      ),
    }));
  };

  const handleToggle = (field) => () => {
    setToggles((prev) => {
      const newToggles = { ...prev, [field]: !prev[field] };
      if (field === "menuItem_Publish" && newToggles.menuItem_Publish) {
        newToggles.is_OutOfStock = false;
        newToggles.is_ShowInKiosk = true;
        newToggles.isSellOnTill = true;
        newToggles.isActiveMobileApp = true;
      } else if (field === "is_OutOfStock" && newToggles.is_OutOfStock) {
        newToggles.menuItem_Publish = false;
        newToggles.is_ShowInKiosk = false;
        newToggles.isSellOnTill = false;
        newToggles.isActiveMobileApp = false;
      } else if (field === "is_OutOfStock" && !newToggles.is_OutOfStock) {
        newToggles.menuItem_Publish = true;
      } else if (
        ["is_ShowInKiosk", "isSellOnTill", "isActiveMobileApp"].includes(field)
      ) {
        const { is_ShowInKiosk, isSellOnTill, isActiveMobileApp } = {
          ...prev,
          [field]: !prev[field],
        };
        newToggles.menuItem_Publish =
          is_ShowInKiosk || isSellOnTill || isActiveMobileApp;
      } else if (field === "menuItem_IsSellingProduct" && !newToggles.menuItem_IsSellingProduct) {
        // When "Is Selling Product" is disabled, clear selling-related selections
        newToggles.isSellOnTill = false;
        newToggles.isActiveMobileApp = false;
        newToggles.allergensEnabled = false;
        newToggles.modifierGroupsEnabled = false;
        newToggles.menuItem_HasVariant = false;

        setSelectors((prevSelectors) => ({
          ...prevSelectors,
          selectedParentCategory: [],
          selectedMenuGroups: [],
          selectedModifierGroups: [],
          selectedAllergens: [],
        }));
        setVariants([
          {
            ...Modifier,
            menuItem_SellingMethodBoth: false,
            reportCat_ID:
              reportingCategory?.rootCat_ID || reportingCategory?.rC_ID
                ? parseInt(reportingCategory.rootCat_ID || reportingCategory.rC_ID)
                : 0,
            menuItem_TaxPercentage:
              !newToggles.isTaxExempt && settings.isTaxEnabled && settings.s_VAT
                ? settings.s_VAT.toString()
                : "",
            menuItem_MeasurementType: formState.menuItem_MeasurementType || "",
            menuItem_DefaultSize: "",
            menuItem_DefaultSizeUnit: "",
            menuitem_DefaultSizeInBaseUnit: 0,
          },
        ]);
      } else if (field === "menuItem_IsSellingProduct" && newToggles.menuItem_IsSellingProduct) {
        // When "Is Selling Product" is enabled, set Is Modifier to false
        newToggles.menuItem_IsModifier = false;
      } else if (field === "productsEnabled" && !newToggles.productsEnabled) {
        setSelectors((prev) => ({ ...prev, selectedProducts: [] }));
      } else if (field === "isTaxExempt") {
        setFormState((prev) => ({
          ...prev,
          menuItem_TaxPercentage: newToggles.isTaxExempt
            ? ""
            : prev.menuItem_TaxPercentage ||
            (settings.isTaxEnabled && settings.s_VAT
              ? settings.s_VAT.toString()
              : ""),
        }));
      }
      return newToggles;
    });
  };

  const handleVariantChange = (index, field, value) => {
    let updatedVariants = variants.map((variant, i) =>
      i === index ? { ...variant, [field]: value } : variant
    );

    if (field === "menuItem_DefaultSize" || field === "menuItem_DefaultSizeUnit") {
      const v = updatedVariants[index] || {};
      const base = calculateDefaultSizeInBaseUnit(
        formState.menuItem_MeasurementType,
        v.menuItem_DefaultSize,
        v.menuItem_DefaultSizeUnit
      );
      updatedVariants[index] = {
        ...v,
        menuItem_MeasurementType: formState.menuItem_MeasurementType || "",
        menuitem_DefaultSizeInBaseUnit: base,
      };
    }

    if (field === "menuItem_IsDefaultVariant" && value === true) {
      updatedVariants = updatedVariants.map((variant, i) => ({
        ...variant,
        menuItem_IsDefaultVariant: i === index ? true : false,
      }));

      const defaultVariant = updatedVariants[index];

      setFormState((prev) => ({
        ...prev,
        menuItem_SalePrice: defaultVariant.menuItem_SalePrice || "0.00",
        menuItem_DeliveryPrice: defaultVariant.menuItem_DeliveryPrice || "0.00",
        menuItem_TakeAwayPrice: defaultVariant.menuItem_TakeAwayPrice || "0.00",
        menuItem_TaxPercentage: defaultVariant.menuItem_TaxPercentage || "0.00",
        menuItem_CostPrice: defaultVariant.menuItem_CostPrice || "0.00",
      }));
    }

    setVariants(updatedVariants);
    if (field === "menuItem_Name" && value && index === variants.length - 1) {
      setVariants([
        ...updatedVariants,
        {
          ...Modifier,
          current_Quantity: 0,
          reorder_Quantity: 0,
          reorder_Level: 0,
          menuItem_SellingMethodBoth: false,
          reportCat_ID:
            reportingCategory?.rootCat_ID || reportingCategory?.rC_ID
              ? parseInt(
                reportingCategory.rootCat_ID || reportingCategory.rC_ID
              )
              : 0,
          menuItem_TaxPercentage:
            !toggles.isTaxExempt && settings.isTaxEnabled && settings.s_VAT
              ? settings.s_VAT.toString()
              : "",
          // No inherit for per-variant size/unit
          menuItem_MeasurementType: formState.menuItem_MeasurementType || "",
          menuItem_DefaultSize: "",
          menuItem_DefaultSizeUnit: "",
          menuitem_DefaultSizeInBaseUnit: 0,
        },
      ]);
    }
  };

  const handleRemoveVariant = (index) => {
    if (variants.length === 1) {
      showErrorToast("At least one variant is required");
      return;
    }
    setVariants(variants.filter((_, i) => i !== index));
  };

  const handleDragStart = (e, index) => {
    dragItem.current = index;
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("application/json", JSON.stringify(index));
    e.currentTarget.style.opacity = "0.5";
  };

  const handleDragEnter = (e, index) => {
    e.preventDefault();
    dragOverItem.current = index;
    e.currentTarget.style.backgroundColor = "#e9ecef";
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "";
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const draggedIndex = JSON.parse(e.dataTransfer.getData("application/json"));
    const overIndex = dragOverItem.current;
    if (
      draggedIndex === overIndex ||
      draggedIndex === undefined ||
      overIndex === undefined
    ) {
      dragItem.current = null;
      dragOverItem.current = null;
      return;
    }
    const newVariants = [...variants];
    const draggedVariant = newVariants[draggedIndex];
    newVariants.splice(draggedIndex, 1);
    newVariants.splice(overIndex, 0, draggedVariant);
    setVariants(newVariants);
    dragItem.current = null;
    dragOverItem.current = null;
  };

  const handleDragEnd = (e) => {
    e.currentTarget.style.opacity = "1";
    document.querySelectorAll("tr").forEach((tr) => {
      tr.style.backgroundColor = "";
    });
    dragItem.current = null;
    dragOverItem.current = null;
  };

  const disablePastDates = (current) => {
    return !current.isSameOrAfter(moment().startOf("day"));
  };

  const handleASTimeChange = (time) => {
    const formattedTime = moment(time).format("HH:mm");
    setFormState((prev) => ({ ...prev, menuItem_ASTime: formattedTime }));
  };

  const handleAETimeChange = (time) => {
    const formattedTime = moment(time).format("HH:mm");
    setFormState((prev) => ({ ...prev, menuItem_AETime: formattedTime }));
  };

  const handleProductTypeSelect = (type) => {
    setFormState((prev) => ({ ...prev, menuItem_RootType: type }));
    closeAllModals();
  };

  const handleReportingCategorySubmit = (categoryData) => {
    setReportingCategory(categoryData);
    closeAllModals();
  };

  const removeProduct = (productId) => {
    setSelectors((prev) => ({
      ...prev,
      selectedProducts: prev.selectedProducts.filter(
        (p) => p.menuItem_ID !== productId
      ),
    }));
  };

  const handleSelectorSubmit = (key) => (selectedItems) => {
    if (key === "selectedProducts") {
      const updatedItems = selectedItems.map((item) => ({
        ...item,
        availableQuantity: item.availableQuantity || "1",
      }));
      setSelectors((prev) => ({ ...prev, [key]: updatedItems }));
    } else {
      setSelectors((prev) => ({ ...prev, [key]: selectedItems }));
    }
    closeAllModals();
  };

  const handleSubmit = async (e, redirectToEdit = false) => {
    e.preventDefault();

    if (!formState.menuItem_Name.trim()) {
      setErrors((prev) => ({
        ...prev,
        menuItem_Name: "Name is required",
      }));
      showErrorToast("Name is required.");
      return;
    }

    if (toggles.menuItem_IsSellingProduct && toggles.menuItem_HasVariant) {
      const validVariants = variants.filter((v) => v.menuItem_Name.trim());
      if (validVariants.length === 0) {
        showErrorToast(
          "At least one variant is required when variants are enabled."
        );
        return;
      }
      // Check if at least one variant is marked as default
      const defaultVariant = validVariants.find(
        (v) => v.menuItem_IsDefaultVariant
      );
      if (!defaultVariant) {
        showErrorToast("At least one variant must be marked as default.");
        return;
      }
      for (const variant of validVariants) {
        const variantSalePrice = parseItemPrice(variant.menuItem_SalePrice);
        if (Number.isNaN(variantSalePrice) || variantSalePrice < 0) {
          showErrorToast("Variant Sale Price must be zero or a positive number.");
          return;
        }
        variant.menuItem_SalePrice = String(variantSalePrice);
        // Cost price can be 0, auto-set to 0 if empty
        if (!variant.menuItem_CostPrice || String(variant.menuItem_CostPrice).trim() === "" || isNaN(parseFloat(variant.menuItem_CostPrice))) {
          variant.menuItem_CostPrice = "0";
        } else if (parseFloat(variant.menuItem_CostPrice) < 0) {
          showErrorToast("Variant Cost Price cannot be negative.");
          return;
        }
        // Tax can be 0, auto-set to 0 if empty
        if (variant.menuItem_TaxPercentage == null || String(variant.menuItem_TaxPercentage).trim() === "" || isNaN(parseFloat(variant.menuItem_TaxPercentage))) {
          variant.menuItem_TaxPercentage = "0";
        } else if (parseFloat(variant.menuItem_TaxPercentage) < 0) {
          showErrorToast("Variant Tax % cannot be negative.");
          return;
        }
      }

      // Variant measurement validation (Weight/Volume only)
      const needsSizeUnit =
        formState.menuItem_MeasurementType === "Weight" ||
        formState.menuItem_MeasurementType === "Volume";
      if (needsSizeUnit) {
        for (let i = 0; i < validVariants.length; i++) {
          const v = validVariants[i];
          const size = parseFloat(v.menuItem_DefaultSize);
          if (!v.menuItem_DefaultSizeUnit || isNaN(size) || size <= 0) {
            showErrorToast(
              `Default size and unit are required for variant: ${v.menuItem_Name || `#${i + 1}`}`
            );
            return;
          }
        }
      }
    } else {
      // Skip sale price validation for non-selling products; allow 0 price
      const salePrice = parseItemPrice(formState.menuItem_SalePrice);
      if (toggles.menuItem_IsSellingProduct && (Number.isNaN(salePrice) || salePrice < 0)) {
        setErrors((prev) => ({
          ...prev,
          menuItem_SalePrice: "Sale Price cannot be negative",
        }));
        showErrorToast("Sale Price cannot be negative.");
        return;
      }
      // Cost price can be 0, auto-set to 0 if empty
      if (!formState.menuItem_CostPrice || formState.menuItem_CostPrice === "" || isNaN(parseFloat(formState.menuItem_CostPrice))) {
        setFormState((prev) => ({ ...prev, menuItem_CostPrice: "0" }));
      } else if (parseFloat(formState.menuItem_CostPrice) < 0) {
        showErrorToast("Cost Price cannot be negative.");
        return;
      }
    }

    if (
      formState.menuItem_Type !== "Combo" &&
      selectors.selectedParentCategory.length === 0 &&
      toggles.menuItem_IsSellingProduct
    ) {
      showErrorToast("At least one category must be selected.");
      return;
    }

    // Skip reporting category validation for combo items
    if (formState.menuItem_Type !== "Combo" && !reportingCategory?.rootCat_ID && !reportingCategory?.rC_ID) {
      showErrorToast("Reporting Category is required.");
      return;
    }

    if (toggles.productsEnabled && selectors.selectedProducts.length === 0) {
      showErrorToast("At least one product must be selected for a combo item.");
      return;
    }

    if (
      toggles.productsEnabled &&
      selectors.selectedProducts.some(
        (product) =>
          !product.availableQuantity || !/^\d+$/.test(product.availableQuantity)
      )
    ) {
      showErrorToast("All selected products must have a valid quantity.");
      return;
    }

    if (toggles.allergensEnabled && selectors.selectedAllergens.length === 0) {
      showErrorToast(
        "At least one allergen must be selected when allergens are enabled."
      );
      return;
    }

    setLoading(true);

    let uploadedImageUrl = toRelativeMediaPath(imageState.menuItem_Image);
    try {
      if (imageState.imageFile) {
        uploadedImageUrl = await uploadCompanyMediaFile(
          axiosInstance,
          APIs,
          CompID,
          imageState.imageFile,
          "Product"
        );
      }
    } catch (err) {
      showErrorToast(err.message || "Failed to upload image");
      setLoading(false);
      return;
    }

    try {
      const isSellingProduct = !!toggles.menuItem_IsSellingProduct;
      const reportingCategoryId =
        reportingCategory?.rootCat_ID || reportingCategory?.rC_ID
          ? parseInt(reportingCategory.rootCat_ID || reportingCategory.rC_ID)
          : 0;
      const categoriesForPayload = isSellingProduct
        ? selectors.selectedParentCategory
        : reportingCategoryId
          ? [reportingCategory]
          : [];
      const menuItemTypeForPayload = IsCombo
        ? "Combo"
        : toggles.menuItem_IsModifier && !isSellingProduct
          ? "Modifier"
          : "Product";
      const mainName = (formState.menuItem_Name || "").trim();
      const buildVariantTitle = (variantName) => {
        const vName = (variantName || "").trim();
        return vName ? `${mainName} (${vName})` : mainName;
      };

      // For variant products: parent (e.g. Pizza) should get the default variant's prices (e.g. Medium 200)
      const variantsForPayload = (toggles.menuItem_IsSellingProduct && toggles.menuItem_HasVariant)
        ? variants.filter((v) => v.menuItem_Name && v.menuItem_Name.trim().length > 0)
        : [];
      const defaultVariantForParent = variantsForPayload.find((v) => v.menuItem_IsDefaultVariant) || variantsForPayload[0];
      const parentSalePrice = toggles.menuItem_HasVariant && defaultVariantForParent
        ? parseItemPrice(defaultVariantForParent.menuItem_SalePrice)
        : parseItemPrice(formState.menuItem_SalePrice);
      const rawDelivery = toggles.menuItem_HasVariant && defaultVariantForParent
        ? parseFloat(defaultVariantForParent.menuItem_DeliveryPrice) || 0
        : parseFloat(formState.menuItem_DeliveryPrice) || 0;
      const rawTakeAway = toggles.menuItem_HasVariant && defaultVariantForParent
        ? parseFloat(defaultVariantForParent.menuItem_TakeAwayPrice) || 0
        : parseFloat(formState.menuItem_TakeAwayPrice) || 0;
      // When variant product: if delivery/takeaway are 0, use sale price (same as backend for main product)
      const parentDeliveryPrice = (toggles.menuItem_HasVariant && rawDelivery <= 0) ? parentSalePrice : rawDelivery;
      const parentTakeAwayPrice = (toggles.menuItem_HasVariant && rawTakeAway <= 0) ? parentSalePrice : rawTakeAway;
      const parentCostPrice = toggles.menuItem_HasVariant && defaultVariantForParent
        ? (defaultVariantForParent.menuItem_CostPrice != null && String(defaultVariantForParent.menuItem_CostPrice).trim() !== "" && !isNaN(parseFloat(defaultVariantForParent.menuItem_CostPrice))
          ? parseFloat(defaultVariantForParent.menuItem_CostPrice)
          : 0)
        : parseFloat(formState.menuItem_CostPrice) || 0;
      const parentTaxPercentage = toggles.menuItem_HasVariant && defaultVariantForParent
        ? (defaultVariantForParent.menuItem_TaxPercentage != null && String(defaultVariantForParent.menuItem_TaxPercentage).trim() !== "" && !isNaN(parseFloat(defaultVariantForParent.menuItem_TaxPercentage))
          ? parseFloat(defaultVariantForParent.menuItem_TaxPercentage)
          : 0)
        : parseFloat(formState.menuItem_TaxPercentage) || 0;

      const payload = {
        menuItem_ID: 0,
        localizeID: formState.localizeID,
        compID: CompID,
        menuItem_Name: formState.menuItem_Name,
        menuItem_KitchenDisplayName: formState.menuItem_KitchenDisplayName,
        menuItem_Detail: formState.menuItem_Detail,
        menuItem_SalePrice: parentSalePrice,
        menuItem_Image: uploadedImageUrl || "",
        menuItem_Orderby: parseInt(formState.menuItem_Orderby) || 0,
        menuItem_Publish: toggles.menuItem_Publish,
        menuItem_DataCreated: new Date().toISOString(),
        menuItem_ExpiryDate: expiryDate ? expiryDate.toISOString() : null,
        menuItem_DateModified: new Date().toISOString(),
        menuItem_DeliveryPrice: parentDeliveryPrice,
        menuItem_TakeAwayPrice: parentTakeAwayPrice,
        menuItem_CostPrice: parentCostPrice,
        menuItem_TaxPercentage: parentTaxPercentage,
        menuItem_SKU: toggles.skuEnabled ? formState.menuItem_SKU : "",
        menuItem_RootType: formState.menuItem_RootType,
        menuItem_SEOTitle: toggles.seoEnabled
          ? formState.menuItem_SEOTitle
          : "",
        menuItem_SEODescription: toggles.seoEnabled
          ? formState.menuItem_SEODescription
          : "",
        menuItem_Permalink: toggles.seoEnabled
          ? formState.menuItem_Permalink
          : "",
        isActiveMobileApp: toggles.isActiveMobileApp,
        is_OutOfStock: toggles.is_OutOfStock,
        isSellOnTill: toggles.isSellOnTill,
        is_ShowInKiosk: toggles.is_ShowInKiosk,
        MenuItem_IsSellingProduct: isSellingProduct,
        hasAllergen:
          isSellingProduct &&
          toggles.allergensEnabled &&
          selectors.selectedAllergens.length > 0,
        // Set MenuItem_HaveModifier true whenever at least one modifier group is selected
        menuItem_HaveModifier:
          isSellingProduct &&
          Array.isArray(selectors.selectedModifierGroups) &&
          selectors.selectedModifierGroups.length > 0,
        categories: categoriesForPayload,
        modifierGroups:
          isSellingProduct && toggles.modifierGroupsEnabled
            ? selectors.selectedModifierGroups
            : [],
        menuGroups: isSellingProduct ? selectors.selectedMenuGroups : [],
        allergens:
          isSellingProduct &&
          toggles.allergensEnabled &&
          selectors.selectedAllergens.length > 0
            ? selectors.selectedAllergens.map((a) => a.allergen_Name).join(", ")
            : "",
        menuItem_PreparationTime: formState.menuItem_PreparationTime.trim(),
        menuItem_ServingSize: formState.menuItem_ServingSize.trim(),
        menuItem_ASTime: formState.menuItem_ASTime || "",
        menuItem_AETime: formState.menuItem_AETime || "",
        menuItem_Rating: parseInt(formState.menuItem_Rating) || 0,
        menuItem_Homefeatured: toggles.menuItem_Homefeatured,
        menuItem_featured: toggles.menuItem_featured,
        menuItem_IsModifier: isSellingProduct ? false : toggles.menuItem_IsModifier,
        menuItem_ModifierType: toggles.menuItem_IsModifier
          ? formState.menuItem_ModifierType || "0"
          : "0",
        menuItem_IsFavorite: toggles.menuItem_IsFavorite,
        menuItem_BarCode: formState.menuItem_BarCode || "",
        menuItem_Type: menuItemTypeForPayload,
        menuItem_ColorCode: formState.menuItem_ColorCode || "",
        retail_Markup: toggles.menuItem_HasVariant
          ? 0
          : parseFloat(formState.retail_Markup) || 0,
        delivery_Markup: toggles.menuItem_HasVariant
          ? 0
          : parseFloat(formState.delivery_Markup) || 0,
        online_Markup: toggles.menuItem_HasVariant
          ? 0
          : parseFloat(formState.online_Markup) || 0,
        current_Quantity: toggles.menuItem_HasVariant
          ? 0
          : parseFloat(formState.current_Quantity) || 0,
        reorder_Quantity: toggles.menuItem_HasVariant
          ? 0
          : parseFloat(formState.reorder_Quantity) || 0,
        reorder_Level: toggles.menuItem_HasVariant
          ? 0
          : parseFloat(formState.reorder_Level) || 0,
        availableQuantity: toggles.menuItem_HasVariant
          ? null
          : parseFloat(formState.availableQuantity) || null,
        orderQuantityLimit: toggles.menuItem_HasVariant
          ? 0
          : parseInt(formState.orderQuantityLimit) || 0,
        brand_ID: parseInt(formState.brand_ID) || 0,
        ingredientID: parseInt(formState.ingredientID) || 0,
        parentMenuItemID: parseInt(formState.parentMenuItemID) || 0,
        itsMasterProductID: parseInt(formState.itsMasterProductID) || 0,
        reportCat_ID: reportingCategoryId,
        stadardUnit: toggles.menuItem_HasVariant
          ? 0
          : parseInt(formState.stadardUnit) || 0,
        unitSize: toggles.menuItem_HasVariant
          ? 0
          : parseInt(formState.unitSize) || 0,
        mP_UnitOfSale: formState.mP_UnitOfSale || "",
        mP_VolumnOfSale: toggles.menuItem_HasVariant
          ? 0
          : parseFloat(formState.mP_VolumnOfSale) || 0,
        menuItem_HasVariant: toggles.menuItem_IsSellingProduct && toggles.menuItem_HasVariant,
        isArchieve: toggles.isArchieve,
        isAllowedtoSetPriceatThePointofSale:
          toggles.isAllowedtoSetPriceatThePointofSale,
        isTaxExempt: toggles.isTaxExempt,
        isPreventGainingLoyalty: toggles.isPreventGainingLoyalty,
        isHaveCustomerSpecificPricing: toggles.isHaveCustomerSpecificPricing,
        isProductisScannableOnly: toggles.isProductisScannableOnly,
        isMasterProduct: toggles.isMasterProduct,
        itHasAMasterProduct: toggles.itHasAMasterProduct,
        menuItem_IsDefaultModifier: toggles.menuItem_IsDefaultModifier,
        menuItem_DefaultModifierTitle:
          formState.menuItem_DefaultModifierTitle || "",
        isShowNotificationExpDate: toggles.isShowNotificationExpDate,
        isShowSocialMediaLink: toggles.isShowSocialMediaLink,
        menuItem_ImageAltText: formState.menuItem_ImageAltText || "",
        appMode: formState.appMode,
        menuItem_MeasurementType: formState.menuItem_MeasurementType || "",
        menuItem_DefaultSize: formState.menuItem_DefaultSize ? parseFloat(formState.menuItem_DefaultSize) : 1,
        menuItem_DefaultSizeUnit: formState.menuItem_DefaultSizeUnit || "",
        menuItem_ContainerType: formState.menuItem_ContainerType || "",
        Menuitem_DefaultSizeInBaseUnit: formState.menuitem_DefaultSizeInBaseUnit || 0,
        menuItem_IsVariant: false,
        menuItem_IsDefaultVariant:
          variants[0]?.menuItem_IsDefaultVariant || false,
        menuItem_DefaultVariantTitle:
          menuItemTypeForPayload === "Combo"
            ? (variants[0]?.menuItem_DefaultVariantTitle || "")
            : mainName,
        menuitem_VariantParentID: parseInt(formState.parentMenuItemID) || 0,
        Products: IsCombo
          ? selectors.selectedProducts
          : (toggles.menuItem_IsSellingProduct && toggles.menuItem_HasVariant)
            ? variants
              .filter(
                (v) => v.menuItem_Name && v.menuItem_Name.trim().length > 0
              )
              .map((v) => {
                const saleNum = parseItemPrice(v.menuItem_SalePrice);
                const costNum = v.menuItem_CostPrice != null && String(v.menuItem_CostPrice).trim() !== "" && !isNaN(parseFloat(v.menuItem_CostPrice))
                  ? parseFloat(v.menuItem_CostPrice)
                  : 0;
                const taxNum = v.menuItem_TaxPercentage != null && String(v.menuItem_TaxPercentage).trim() !== "" && !isNaN(parseFloat(v.menuItem_TaxPercentage))
                  ? parseFloat(v.menuItem_TaxPercentage)
                  : 0;
                return {
                  ...v,
                  current_Quantity: 0,
                  reorder_Quantity: 0,
                  reorder_Level: 0,
                  isActiveMobileApp: toggles.isActiveMobileApp,
                  menuItem_Publish: toggles.menuItem_Publish,
                  menuItem_DefaultVariantTitle: buildVariantTitle(v.menuItem_Name),
                  menuItem_SalePrice: saleNum,
                  menuItem_DeliveryPrice: parseItemPrice(v.menuItem_DeliveryPrice),
                  menuItem_TakeAwayPrice: parseItemPrice(v.menuItem_TakeAwayPrice),
                  menuItem_CostPrice: costNum,
                  menuItem_TaxPercentage: taxNum,
                  menuItem_MeasurementType: formState.menuItem_MeasurementType || "",
                  menuItem_DefaultSize: v.menuItem_DefaultSize && String(v.menuItem_DefaultSize).trim() !== "" && !isNaN(parseFloat(v.menuItem_DefaultSize))
                    ? parseFloat(v.menuItem_DefaultSize)
                    : 0,
                  menuItem_DefaultSizeUnit: v.menuItem_DefaultSizeUnit || "",
                  Menuitem_DefaultSizeInBaseUnit: (v.menuitem_DefaultSizeInBaseUnit ?? v.Menuitem_DefaultSizeInBaseUnit) ?? 0,
                  reportCat_ID:
                    reportingCategory?.rootCat_ID || reportingCategory?.rC_ID
                      ? parseInt(
                        reportingCategory.rootCat_ID || reportingCategory.rC_ID
                      )
                      : 0,
                };
              })
            : [],
        BranchCompIDs: isParentBranch && selectedBranches.length > 0
          ? selectedBranches
              .map(b => {
                // Handle both number and object types
                if (typeof b === 'number') {
                  return parseInt(b, 10);
                }
                // Handle both camelCase and PascalCase property names
                const branchId = b.CompID || b.compID || b.branchCompID || b.BranchCompID;
                return branchId ? parseInt(branchId, 10) : null;
              })
              .filter(id => id !== null && !isNaN(id) && id > 0) // Filter out invalid values
          : undefined,
      };

      const response = await axiosInstance.post(
        APIs.POST_CREATE_MENU_ITEM,
        payload
      );
      if (response.data.status) {
        showSuccessToast("Item created successfully");
        if (redirectToEdit) {
          // Try different possible response structures
          const itemId = response.data.data?.MenuItem_ID ||
            response.data.data?.menuItem_ID ||
            response.data.data?.id ||
            response.data?.MenuItem_ID ||
            response.data?.menuItem_ID;
          if (itemId) {
            navigate(`/items/updateItem/${itemId}`);
          } else {
            showErrorToast("Item created but could not redirect to edit page. Please navigate manually.");
            navigate("/items/manageItems");
          }
        } else {
          navigate("/items/manageItems");
        }
      } else {
        showErrorToast(response.data.message || "Failed to create item");
      }
    } catch (error) {
      showErrorToast(error.response?.data?.message || "Failed to create item");
    } finally {
      setLoading(false);
    }
  };

  const renderBreadcrumb = () => (
    <div className="d-flex align-items-center mb-3">
      <div>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#/">Home</a>
          </li>
          <li className="breadcrumb-item">
            <Link to="/items/manageItems">Manage Items</Link>
          </li>
          <li className="breadcrumb-item active">Add Item</li>
        </ol>
        <h1 className="page-header mb-0">
          {IsCombo ? "Add Combo Item" : "Add Item"}
        </h1>
      </div>
      <div className="ms-auto d-flex gap-2">
        <button
          onClick={(e) => handleSubmit(e, true)}
          className="btn btn-rounded px-4 rounded-pill"
          style={{
            backgroundColor: themeColor,
            background: `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`,
            border: 'none',
            color: 'white',
            borderRadius: '8px',
            padding: '8px 16px',
            fontSize: '14px',
            fontWeight: '600',
            transition: 'all 0.3s ease',
            boxShadow: `0 2px 8px ${themeColor}40`
          }}
          onMouseEnter={(e) => {
            e.target.style.background = `linear-gradient(135deg, ${themeColor}dd 0%, ${themeColor} 100%)`;
            e.target.style.transform = 'translateY(-1px)';
            e.target.style.boxShadow = `0 4px 12px ${themeColor}60`;
          }}
          onMouseLeave={(e) => {
            e.target.style.background = `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`;
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = `0 2px 8px ${themeColor}40`;
          }}
        >
          Save and Edit
        </button>
        <button
          onClick={(e) => handleSubmit(e, false)}
          className="btn btn-rounded px-4 rounded-pill"
          style={{
            backgroundColor: themeColor,
            background: `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`,
            border: 'none',
            color: 'white',
            borderRadius: '8px',
            padding: '8px 16px',
            fontSize: '14px',
            fontWeight: '600',
            transition: 'all 0.3s ease',
            boxShadow: `0 2px 8px ${themeColor}40`
          }}
          onMouseEnter={(e) => {
            e.target.style.background = `linear-gradient(135deg, ${themeColor}dd 0%, ${themeColor} 100%)`;
            e.target.style.transform = 'translateY(-1px)';
            e.target.style.boxShadow = `0 4px 12px ${themeColor}60`;
          }}
          onMouseLeave={(e) => {
            e.target.style.background = `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`;
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = `0 2px 8px ${themeColor}40`;
          }}
        >
          Save
        </button>
      </div>
    </div>
  );


  
  // Additional Options component
  const renderAdditionalOptions = () => (
    <Panel className="h-100">
      <PanelHeader
        style={{
          backgroundColor: themeColor,
          color: 'white',
          border: 'none',
          borderRadius: '10px 10px 0 0',
          padding: '15px 20px',
          fontWeight: '600',
          fontSize: '16px'
        }}
      >
        <i className="fas fa-sliders-h me-2"></i>
        Additional Options
      </PanelHeader>
      <PanelBody
        style={{
          padding: '25px',
          backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
          borderRadius: '0 0 10px 10px',
          border: `1px solid ${themeColor}20`,
          height: '100%'
        }}
      >
        {/* Barcode Section */}
        <div className="row g-3 mb-3">
          <div className="col-12">
            <FormInput
              label="Barcode"
              value={formState.menuItem_BarCode}
              onchange={handleInputChange("menuItem_BarCode")}
              type="text"
              placeHolder="Barcode"
              name="menuItem_BarCode"
            />
          </div>
        </div>

        {/* Preparation Time and Serving Size */}
        <div className="row g-3 mb-3">
          <div className="col-12">
            <FormInput
              label="Preparation Time"
              value={formState.menuItem_PreparationTime}
              onchange={handleInputChange("menuItem_PreparationTime")}
              type="text"
              placeHolder="Preparation Time (e.g., 40)"
              name="menuItem_PreparationTime"
            />
          </div>
          <div className="col-12">
            <FormInput
              label="Serving Size"
              value={formState.menuItem_ServingSize}
              onchange={handleInputChange("menuItem_ServingSize")}
              type="text"
              placeHolder="Serving Size (e.g., 1)"
              name="menuItem_ServingSize"
            />
          </div>
        </div>

        {/* Tax Exempt Section */}
        <div className="row g-3 mb-3">
          <div className="col-12">
            <div className="d-flex align-items-center">
              <ToggleSwitch
                isChecked={toggles.isTaxExempt}
                onToggle={handleToggle("isTaxExempt")}
                label="Tax Exempt"
                name="isTaxExempt"
                themeColor={themeColor}
              />
            </div>
          </div>
        </div>

        {/* SKU Enable Section */}
        <div className="row g-3 mb-3">
          <div className="col-12">
            <div className="d-flex align-items-center gap-3">
              <div className="flex-shrink-0">
                <ToggleSwitch
                  isChecked={toggles.skuEnabled}
                  onToggle={handleToggle("skuEnabled")}
                  label="SKU Enable"
                  name="skuEnabled"
                  themeColor={themeColor}
                />
              </div>
              {toggles.skuEnabled && (
                <div className="flex-grow-1">
                  <FormInput
                    placeHolder="SKU Code"
                    type="text"
                    value={formState.menuItem_SKU}
                    onchange={handleInputChange("menuItem_SKU")}
                    className="form-control"
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Expiry Date Section */}
        <div className="row g-3 mb-3">
          <div className="col-12">
            <div className="d-flex align-items-center gap-3">
              <div className="flex-shrink-0">
                <ToggleSwitch
                  isChecked={toggles.expiryDateEnabled}
                  onToggle={handleToggle("expiryDateEnabled")}
                  label="Expiry Date"
                  name="expiryDateEnabled"
                  themeColor={themeColor}
                />
              </div>
              {toggles.expiryDateEnabled && (
                <div className="flex-grow-1">
                  <DebugMUIDatePicker
                    value={expiryDate}
                    onChange={(date) => setExpiryDate(date)}
                    placeholder="Select expiry date"
                    name="expiryDate"
                    clearable={true}
                    minDate={new Date()} // Disable past dates
                  />
                </div>
              )}
            </div>
          </div>
        </div>


      </PanelBody>
    </Panel>
  );

  // Additional Flags component - 6 columns
  const renderAdditionalFlags = () => (
    <div className="col-6">
      <Panel className="h-100">
        <PanelHeader
          style={{
            backgroundColor: themeColor,
            color: 'white',
            border: 'none',
            borderRadius: '10px 10px 0 0',
            padding: '15px 20px',
            fontWeight: '600',
            fontSize: '16px'
          }}
        >
          <i className="fas fa-flag me-2"></i>
          Additional Flags
        </PanelHeader>
        <PanelBody
          style={{
            padding: '25px',
            backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
            borderRadius: '0 0 10px 10px',
            border: `1px solid ${themeColor}20`,
            height: '100%'
          }}
        >
          <div className="row row-cols-1 g-3">
            {[
              { label: "Tax Exempt", field: "isTaxExempt" },
              { label: "Prevent Loyalty Points", field: "isPreventGainingLoyalty" },
              { label: "Show Expiry Notification", field: "isShowNotificationExpDate" },
              { label: "Is Archived", field: "isArchieve" },
              { label: "Set Price at POS", field: "isAllowedtoSetPriceatThePointofSale" },
              { label: "Show Social Media Link", field: "isShowSocialMediaLink" },
            ].map(({ label, field }) => (
              <div key={field} className="col-12">
                <div
                  className="d-flex align-items-center p-3 rounded"
                  style={{
                    backgroundColor: isDarkMode ? '#3c4043' : '#f8f9fa',
                    border: `1px solid ${themeColor}20`,
                    transition: 'all 0.3s ease'
                  }}
                >
                  <ToggleSwitch
                    isChecked={toggles[field]}
                    onToggle={handleToggle(field)}
                    label={label}
                    name={field}
                    themeColor={themeColor}
                  />
                </div>
              </div>
            ))}
          </div>
        </PanelBody>
      </Panel>
    </div>
  );

  // Other section component - 6 columns
  const renderOtherSection = () => (
    <div className="col-6">
      <Panel className="h-100">
        <PanelHeader
          style={{
            backgroundColor: themeColor,
            color: 'white',
            border: 'none',
            borderRadius: '10px 10px 0 0',
            padding: '15px 20px',
            fontWeight: '600',
            fontSize: '16px'
          }}
        >
          <i className="fas fa-cog me-2"></i>
          Other Settings
        </PanelHeader>
        <PanelBody
          style={{
            padding: '25px',
            backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
            borderRadius: '0 0 10px 10px',
            border: `1px solid ${themeColor}20`,
            height: '100%'
          }}
        >
          <div className="row g-3" style={{ display: 'none' }}>
            {/* <div className="col-12">
              <label
                className="form-label fw-medium"
                style={{
                  color: isDarkMode ? '#ffffff' : '#000000'
                }}
              >
                Available Start Time
              </label>
              <DateTime
                dateFormat={false}
                timeFormat="HH:mm"
                value={formState.menuItem_ASTime}
                onChange={handleASTimeChange}
                inputProps={{
                  placeholder: "Select start time (e.g., 09:00)",
                  className: `form-control ${isDarkMode ? 'dark-mode-input' : 'light-mode-input'}`,
                  style: {
                    borderRadius: "10px",
                    border: isDarkMode ? '1px solid #404040' : '1px solid #D9D9D9',
                    background: isDarkMode ? '#2d3436' : '#F9F9F9',
                    color: isDarkMode ? '#ffffff' : '#000000',
                    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                  }
                }}
              />
            </div>
            <div className="col-12">
              <label
                className="form-label fw-medium"
                style={{
                  color: isDarkMode ? '#ffffff' : '#000000'
                }}
              >
                Available End Time
              </label>
              <DateTime
                dateFormat={false}
                timeFormat="HH:mm"
                value={formState.menuItem_AETime}
                onChange={handleAETimeChange}
                inputProps={{
                  placeholder: "Select end time (e.g., 17:00)",
                  className: `form-control ${isDarkMode ? 'dark-mode-input' : 'light-mode-input'}`,
                  style: {
                    borderRadius: "10px",
                    border: isDarkMode ? '1px solid #404040' : '1px solid #D9D9D9',
                    background: isDarkMode ? '#2d3436' : '#F9F9F9',
                    color: isDarkMode ? '#ffffff' : '#000000',
                    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
                  }
                }}
              />
            </div>
            <div className="col-12">
              <FormInput
                label="Rating"
                value={formState.menuItem_Rating}
                onchange={handleInputChange("menuItem_Rating")}
                type="number"
                placeHolder="Rating (0-5)"
                name="menuItem_Rating"
                min="0"
                max="5"
                step="0.1"
              />
            </div>
            <div className="col-12">
              <FormInput
                label="Barcode"
                value={formState.menuItem_BarCode}
                onchange={handleInputChange("menuItem_BarCode")}
                type="text"
                placeHolder="Barcode"
                name="menuItem_BarCode"
              />
            </div> */}
          </div>
        </PanelBody>
      </Panel>
    </div>
  );

  // Basic Information Panel
  const renderBasicInfoPanel = () => (
    <Panel className="mb-4">
      <PanelHeader
        style={{
          backgroundColor: themeColor,
          color: 'white',
          border: 'none',
          borderRadius: '10px 10px 0 0',
          padding: '15px 20px',
          fontWeight: '600',
          fontSize: '16px'
        }}
      >
        <i className="fas fa-info-circle me-2"></i>
        Basic Information
      </PanelHeader>
      <PanelBody
        style={{
          padding: '25px',
          backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
          borderRadius: '0 0 10px 10px',
          border: `1px solid ${themeColor}20`
        }}
      >
        <div className="row g-4">
          <div className="col-md-6">
            <FormInput
              label={IsCombo ? "Combo Name *" : "Item Name *"}
              value={formState.menuItem_Name}
              onchange={handleInputChange("menuItem_Name")}
              type="text"
              placeHolder="Name"
              name="menuItem_Name"
              required
              error={errors.menuItem_Name}
            />

            {/* Hidden Kitchen Name field */}
            <div style={{ display: 'none' }}>
              <FormInput
                label={IsCombo ? "Combo Kitchen Name " : "Kitchen Name "}
                value={formState.menuItem_KitchenDisplayName}
                onchange={handleInputChange("menuItem_KitchenDisplayName")}
                type="text"
                placeHolder="Kitchen Name"
                name="menuItem_KitchenDisplayName"
              />
            </div>

            <div className="mb-4">
              <label className="form-label fw-medium">
                <b>{IsCombo ? "Combo Description" : "Item Description"}</b>
              </label>
              <textarea
                className={`form-control ${isDarkMode ? 'dark-mode-input' : 'light-mode-input'}`}
                rows={6}
                placeholder="Description (max 500 characters)"
                value={formState.menuItem_Detail}
                onChange={handleInputChange("menuItem_Detail")}
                style={{
                  borderRadius: "10px",
                  border: isDarkMode ? "1px solid #404040" : "1px solid #D9D9D9",
                  background: isDarkMode ? "#2d3436" : "#F9F9F9",
                  color: isDarkMode ? "#ffffff" : "#000000",
                  transition: "border-color 0.2s ease, box-shadow 0.2s ease",
                }}
              />
            </div>


          </div>

          <div className="col-md-6">
            {/* Hidden Product Type field */}
            <div style={{ display: 'none' }}>
              <FormInput
                label="Product Type"
                value={formState.menuItem_RootType}
                onchange={handleInputChange("menuItem_RootType")}
                type="text"
                placeHolder="Select Product Type"
                name="menuItem_RootType"
                icon="fa fa-caret-down"
                iconOnClick={() => openModal("isModalOpen")}
              />
            </div>

            {/* Hidden Color Code field */}
            <div style={{ display: 'none' }}>
              <FormInput
                label="Color Code"
                value={formState.menuItem_ColorCode}
                onchange={handleInputChange("menuItem_ColorCode")}
                type="color"
                name="menuItem_ColorCode"
              />
            </div>

            {/* Image Upload Section */}
            <div className="mb-3">
              <div
                className="card p-3"
                style={{
                  backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                  border: `1px solid ${themeColor}20`,
                  color: isDarkMode ? '#ffffff' : '#000000',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '10px'
                }}
              >
                <div className="text-center">
                  <ImageUploadWithGallery
                    compID={CompID}
                    mediaCategory="Product"
                    imageUrl={imageState.menuItem_Image}
                    imageFile={imageState.imageFile}
                    setImage={(url, file) =>
                      setImageState({ menuItem_Image: url, imageFile: file })
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            {!IsCombo && (
              <>

                {/* Product Settings Switches - Moved from Product Settings Panel */}
                <div className="row g-3 mb-4">
                  <div className="col-md-6 col-lg-3">
                    <div className="d-flex align-items-center p-3 rounded"
                      style={{
                        backgroundColor: isDarkMode ? '#3c4043' : '#f8f9fa',
                        border: `1px solid ${themeColor}20`,
                        transition: 'all 0.3s ease'
                      }}
                    >
                      <ToggleSwitch
                        isChecked={toggles.menuItem_Publish}
                        onToggle={handleToggle("menuItem_Publish")}
                        label="Active"
                        name="menuItem_Publish"
                        themeColor={themeColor}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="d-flex align-items-center p-3 rounded"
                      style={{
                        backgroundColor: isDarkMode ? '#3c4043' : '#f8f9fa',
                        border: `1px solid ${themeColor}20`,
                        transition: 'all 0.3s ease'
                      }}
                    >
                      <ToggleSwitch
                        isChecked={toggles.menuItem_IsSellingProduct || false}
                        onToggle={handleToggle("menuItem_IsSellingProduct")}
                        label="Is Selling Product"
                        name="menuItem_IsSellingProduct"
                        themeColor={themeColor}
                      />
                    </div>
                  </div>
                  {!toggles.menuItem_IsSellingProduct && (
                    <div className="col-md-6 col-lg-3">
                      <div
                        className="d-flex align-items-center p-3 rounded"
                        style={{
                          backgroundColor: isDarkMode ? "#3c4043" : "#f8f9fa",
                          border: `1px solid ${themeColor}20`,
                          transition: "all 0.3s ease",
                        }}
                      >
                        <ToggleSwitch
                          isChecked={toggles.menuItem_IsModifier || false}
                          onToggle={handleToggle("menuItem_IsModifier")}
                          label="Is Modifier"
                          name="menuItem_IsModifier"
                          themeColor={themeColor}
                        />
                      </div>
                    </div>
                  )}
                  {toggles.menuItem_IsSellingProduct && (
                    <>
                      <div className="col-md-6 col-lg-3">
                        <div className="d-flex align-items-center p-3 rounded"
                          style={{
                            backgroundColor: isDarkMode ? '#3c4043' : '#f8f9fa',
                            border: `1px solid ${themeColor}20`,
                            transition: 'all 0.3s ease'
                          }}
                        >
                          <ToggleSwitch
                            isChecked={toggles.isSellOnTill}
                            onToggle={handleToggle("isSellOnTill")}
                            label="Show in POS"
                            name="isSellOnTill"
                            themeColor={themeColor}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-3">
                        <div className="d-flex align-items-center p-3 rounded"
                          style={{
                            backgroundColor: isDarkMode ? '#3c4043' : '#f8f9fa',
                            border: `1px solid ${themeColor}20`,
                            transition: 'all 0.3s ease'
                          }}
                        >
                          <ToggleSwitch
                            isChecked={toggles.isActiveMobileApp}
                            onToggle={handleToggle("isActiveMobileApp")}
                            label="Show in Online"
                            name="isActiveMobileApp"
                            themeColor={themeColor}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div className="mb-3">
                  {toggles.menuItem_IsSellingProduct && formState.menuItem_Type !== "Combo" && (
                    <ToggleSwitch
                      isChecked={toggles.menuItem_HasVariant}
                      onToggle={handleToggle("menuItem_HasVariant")}
                      label="Is Product have multiple variants"
                      name="menuItem_HasVariant"
                      themeColor={themeColor}
                    />
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </PanelBody>
    </Panel>
  );

  // Pricing Panel
  const renderPricingPanel = () => (
    <Panel className="mb-4">
      <PanelHeader
        style={{
          backgroundColor: themeColor,
          color: 'white',
          border: 'none',
          borderRadius: '10px 10px 0 0',
          padding: '15px 20px',
          fontWeight: '600',
          fontSize: '16px'
        }}
      >
        <i className="fas fa-dollar-sign me-2"></i>
        Pricing Information
      </PanelHeader>
      <PanelBody
        style={{
          padding: '25px',
          backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
          borderRadius: '0 0 10px 10px',
          border: `1px solid ${themeColor}20`
        }}
      >
        {!toggles.menuItem_HasVariant && (
          <div className="row g-4">
            <div className="col-md-6">

              <div className="row g-3">

                <div className="col-12">
                  <FormInput
                    label="Sale Price *"
                    value={getDisplayValue(formState.menuItem_SalePrice)}
                    onchange={handleInputChange("menuItem_SalePrice")}
                    type="number"
                    placeHolder="0"
                    name="menuItem_SalePrice"
                    required
                    error={errors.menuItem_SalePrice}
                    prepend={getCurrencySymbol(compCurrency)}
                  />
                </div>

                <div className="col-8">
                  <FormInput
                    label="Cost Price"
                    value={getDisplayValue(formState.menuItem_CostPrice)}
                    onchange={handleInputChange("menuItem_CostPrice")}
                    type="number"
                    placeHolder="0"
                    name="menuItem_CostPrice"
                    prepend={getCurrencySymbol(compCurrency)}
                  />
                </div>

                <div className="col-4">
                  <FormInput
                    label="Tax (Percentage)"
                    value={getDisplayValue(formState.menuItem_TaxPercentage)}
                    onchange={handleInputChange("menuItem_TaxPercentage")}
                    type="text"
                    placeHolder="0"
                    name="menuItem_TaxPercentage"
                    disabled={toggles.isTaxExempt}
                    title={
                      formState.menuItem_TaxPercentage &&
                        settings.s_VAT &&
                        formState.menuItem_TaxPercentage ===
                        settings.s_VAT.toString()
                        ? "Default tax rate from settings - you can edit this value"
                        : "Enter tax percentage"
                    }
                  />
                </div>

              </div>
            </div>

            <div className="col-md-6">

              <div className="row g-3">
                <div className="col-6">
                  <FormInput
                    label="Takeaway Price"
                    value={getDisplayValue(formState.menuItem_TakeAwayPrice)}
                    onchange={handleInputChange("menuItem_TakeAwayPrice")}
                    type="number"
                    placeHolder="0"
                    name="menuItem_TakeAwayPrice"
                    prepend={getCurrencySymbol(compCurrency)}
                  />
                </div>
                <div className="col-6">
                  <FormInput
                    label="Delivery Price"
                    value={getDisplayValue(formState.menuItem_DeliveryPrice)}
                    onchange={handleInputChange("menuItem_DeliveryPrice")}
                    type="number"
                    placeHolder="0"
                    name="menuItem_DeliveryPrice"
                    prepend={getCurrencySymbol(compCurrency)}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </PanelBody>
    </Panel>
  );

  // Measurements Panel
  const renderMeasurementsPanel = () => (
    <Panel className="mb-4">
      <PanelHeader
        style={{
          backgroundColor: themeColor,
          color: 'white',
          border: 'none',
          borderRadius: '10px 10px 0 0',
          padding: '15px 20px',
          fontWeight: '600',
          fontSize: '16px'
        }}
      >
        <i className="fas fa-ruler-combined me-2"></i>
        Measurements
      </PanelHeader>
      <PanelBody
        style={{
          padding: '25px',
          backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
          borderRadius: '0 0 10px 10px',
          border: `1px solid ${themeColor}20`
        }}
      >
        <div className="row g-4">
          {/* Measured Section */}
          <div className="col-12">
            <label className="form-label fw-medium mb-3" style={{ color: isDarkMode ? '#ffffff' : '#000000' }}>
              Measured
            </label>
            <div className="d-flex gap-2 mb-3">
              {["Unit", "Volume", "Weight"].map((type) => (
                <button
                  key={type}
                  type="button"
                  onClick={() => {
                    setFormState((prev) => ({
                      ...prev,
                      menuItem_MeasurementType: type,
                      menuItem_DefaultSizeUnit: "", // Reset unit when measurement type changes
                      menuItem_DefaultSize: type === "Unit" ? "" : prev.menuItem_DefaultSize, // Clear default size for Unit
                      menuItem_ContainerType: type === "Unit" ? "" : prev.menuItem_ContainerType, // Clear container for Unit
                    }));
                  }}
                  style={{
                    flex: 1,
                    padding: '10px 16px',
                    border: `2px solid ${formState.menuItem_MeasurementType === type
                      ? themeColor
                      : isDarkMode ? '#404040' : '#dee2e6'
                      }`,
                    borderRadius: '8px',
                    backgroundColor:
                      formState.menuItem_MeasurementType === type
                        ? `${themeColor}20`
                        : isDarkMode ? '#2d3436' : '#ffffff',
                    color:
                      formState.menuItem_MeasurementType === type
                        ? themeColor
                        : isDarkMode ? '#ffffff' : '#000000',
                    fontWeight: formState.menuItem_MeasurementType === type ? '600' : '400',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                  }}
                  onMouseEnter={(e) => {
                    if (formState.menuItem_MeasurementType !== type) {
                      e.target.style.borderColor = themeColor;
                      e.target.style.backgroundColor = `${themeColor}10`;
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (formState.menuItem_MeasurementType !== type) {
                      e.target.style.borderColor = isDarkMode ? '#404040' : '#dee2e6';
                      e.target.style.backgroundColor = isDarkMode ? '#2d3436' : '#ffffff';
                    }
                  }}
                >
                  {type === "Unit" ? "In units" : type === "Volume" ? "By volume" : "By weight"}
                </button>
              ))}
            </div>
            {!toggles.menuItem_HasVariant &&
              formState.menuItem_MeasurementType &&
              formState.menuItem_MeasurementType !== "Unit" && (
                <p className="text-muted small mb-0" style={{ color: isDarkMode ? '#adb5bd' : '#6c757d' }}>
                  This means that 1 Unit of {formState.menuItem_Name || "this product"} = {formState.menuItem_DefaultSize || "1"} {formState.menuItem_DefaultSizeUnit || "unit"}
                </p>
              )}
            
          </div>

          {/* Sale Method Section - Only show for Weight and Volume (NOT for variants) and when Is Selling Product is true */}
          {!toggles.menuItem_HasVariant &&
            toggles.menuItem_IsSellingProduct &&
            (formState.menuItem_MeasurementType === "Weight" ||
              formState.menuItem_MeasurementType === "Volume") && (
            <div className="col-12 mt-3">
              <div className="d-flex align-items-center p-3 rounded"
                style={{
                  backgroundColor: isDarkMode ? '#3c4043' : '#f8f9fa',
                  border: `1px solid ${themeColor}20`,
                  transition: 'all 0.3s ease'
                }}
              >
                <ToggleSwitch
                  isChecked={toggles.menuItem_SellingMethodBoth || false}
                  onToggle={handleToggle("menuItem_SellingMethodBoth")}
                  label="Is Both Sale Method (By Weight/Volume & Price Based)"
                  name="menuItem_SellingMethodBoth"
                  themeColor={themeColor}
                />
              </div>
            </div>
          )}

          {/* Product-level Default Size/Unit/Container (only when variants are disabled) */}
          {!toggles.menuItem_HasVariant &&
            (formState.menuItem_MeasurementType === "Volume" || formState.menuItem_MeasurementType === "Weight") && (
              <div className="col-12">
                <div className="row g-3">
                  <div className="col-4">
                    <label className="form-label fw-medium mb-2" style={{ color: isDarkMode ? '#ffffff' : '#000000' }}>
                      Default Size
                    </label>
                    <FormInput
                      type="number"
                      value={formState.menuItem_DefaultSize || ""}
                      onchange={handleInputChange("menuItem_DefaultSize")}
                      placeHolder="1"
                      name="menuItem_DefaultSize"
                      step="0.01"
                    />
                  </div>
                  <div className="col-4">
                    <label className="form-label fw-medium mb-2" style={{ color: isDarkMode ? '#ffffff' : '#000000', visibility: 'hidden' }}>
                      Unit
                    </label>
                    <select
                      className="form-control"
                      value={formState.menuItem_DefaultSizeUnit || ""}
                      onChange={(e) =>
                        setFormState((prev) => ({
                          ...prev,
                          menuItem_DefaultSizeUnit: e.target.value,
                        }))
                      }
                      style={{
                        borderRadius: "8px",
                        border: isDarkMode ? "1px solid #404040" : "1px solid #D9D9D9",
                        background: isDarkMode ? "#2d3436" : "#F9F9F9",
                        color: isDarkMode ? "#ffffff" : "#000000",
                        padding: "8px 12px",
                      }}
                    >
                      <option value="">Select unit</option>
                      {filteredUnits.map((unit) => {
                        const unitId = unit.MeasureID || unit.measureID || unit.unitID || unit.id;
                        const unitName = unit.MeasureName || unit.measureName || unit.unitName || unit.name;
                        const unitSymbol = unit.symbol || unit.Symbol || unitName;
                        return (
                          <option key={unitId} value={unitName}>
                            {unitSymbol}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-4">
                    <label className="form-label fw-medium mb-2" style={{ color: isDarkMode ? '#ffffff' : '#000000' }}>
                      Container
                    </label>
                    <select
                      className="form-control"
                      value={formState.menuItem_ContainerType || ""}
                      onChange={(e) =>
                        setFormState((prev) => ({
                          ...prev,
                          menuItem_ContainerType: e.target.value,
                        }))
                      }
                      style={{
                        borderRadius: "8px",
                        border: isDarkMode ? "1px solid #404040" : "1px solid #D9D9D9",
                        background: isDarkMode ? "#2d3436" : "#F9F9F9",
                        color: isDarkMode ? "#ffffff" : "#000000",
                        padding: "8px 12px",
                      }}
                    >
                      <option value="">Select container</option>
                      {["Unit", "Packet", "Box", "Bottle", "Can", "Bag", "Carton", "Case"].map((container) => (
                        <option key={container} value={container}>
                          {container}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            )}
        </div>
      </PanelBody>
    </Panel>
  );

  // Variants Panel
  const renderVariantsPanel = () => (
    <Panel className="mb-4">
      <PanelHeader
        style={{
          backgroundColor: themeColor,
          color: 'white',
          border: 'none',
          borderRadius: '10px 10px 0 0',
          padding: '15px 20px',
          fontWeight: '600',
          fontSize: '16px'
        }}
      >
        <i className="fas fa-layer-group me-2"></i>
        Product Variants
      </PanelHeader>
      <PanelBody
        style={{
          padding: '25px',
          backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
          borderRadius: '0 0 10px 10px',
          border: `1px solid ${themeColor}20`
        }}
      >
        {!IsCombo && toggles.menuItem_HasVariant && (
          <div className="table-responsive">
            <table className="table table-hover">
              <thead style={{
                backgroundColor: isDarkMode ? "#404040" : "#f8f9fa",
                color: isDarkMode ? "#ffffff" : "#000000"
              }}>
                <tr>
                  <th>Variant</th>
              
                  {(formState.menuItem_MeasurementType === "Weight" || formState.menuItem_MeasurementType === "Volume") && (
                    <>
                      <th>Default Size</th>
                      <th>Unit</th>
                    </>
                  )}
                  <th>Cost Price</th>
                  <th>Tax %</th>
                  <th>Sale Price</th>
                  <th>Delivery Price</th>
                  <th>Takeaway Price</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {variants.map((variant, index) => (
                  <tr
                    key={index}
                    draggable
                    onDragStart={(e) => handleDragStart(e, index)}
                    onDragEnter={(e) => handleDragEnter(e, index)}
                    onDragLeave={handleDragLeave}
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                    onDragEnd={handleDragEnd}
                    style={{
                      backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                      color: isDarkMode ? '#ffffff' : '#000000'
                    }}
                  >
                    <td className="align-middle">
                      <FormInput
                        type="text"
                        value={variant.menuItem_Name || ""}
                        placeHolder="Enter Variant Name"
                        draggable={false}
                        onDragStart={(e) => e.stopPropagation()}
                        onchange={(e) =>
                          handleVariantChange(
                            index,
                            "menuItem_Name",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    
                    {(formState.menuItem_MeasurementType === "Weight" || formState.menuItem_MeasurementType === "Volume") && (
                      <>
                        <td className="align-middle">
                          <FormInput
                            type="number"
                            value={variant.menuItem_DefaultSize || ""}
                            placeHolder="1"
                            step="0.01"
                            draggable={false}
                            onDragStart={(e) => e.stopPropagation()}
                            onchange={(e) =>
                              handleVariantChange(
                                index,
                                "menuItem_DefaultSize",
                                e.target.value
                              )
                            }
                          />
                        </td>
                        <td className="align-middle">
                          <select
                            className="form-control"
                            value={variant.menuItem_DefaultSizeUnit || ""}
                            onChange={(e) =>
                              handleVariantChange(
                                index,
                                "menuItem_DefaultSizeUnit",
                                e.target.value
                              )
                            }
                            onMouseDown={(e) => e.stopPropagation()}
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              borderRadius: "8px",
                              border: isDarkMode ? "1px solid #404040" : "1px solid #D9D9D9",
                              background: isDarkMode ? "#2d3436" : "#F9F9F9",
                              color: isDarkMode ? "#ffffff" : "#000000",
                              padding: "8px 12px",
                            }}
                          >
                            <option value="">Select unit</option>
                            {filteredUnits.map((unit) => {
                              const unitId = unit.MeasureID || unit.measureID || unit.unitID || unit.id;
                              const unitName = unit.MeasureName || unit.measureName || unit.unitName || unit.name;
                              const unitSymbol = unit.symbol || unit.Symbol || unitName;
                              return (
                                <option key={unitId} value={unitName}>
                                  {unitSymbol}
                                </option>
                              );
                            })}
                          </select>
                        </td>
                      </>
                    )}
                    <td className="align-middle">
                      <FormInput
                        type="number"
                        value={variant.menuItem_CostPrice || ""}
                        placeHolder="0.00"
                        step="0.01"
                        draggable={false}
                        onDragStart={(e) => e.stopPropagation()}
                        onchange={(e) =>
                          handleVariantChange(
                            index,
                            "menuItem_CostPrice",
                            e.target.value
                          )
                        }
                        prepend={getCurrencySymbol(compCurrency)}
                      />
                    </td>
                    <td className="align-middle">
                      <FormInput
                        type="number"
                        value={variant.menuItem_TaxPercentage || ""}
                        placeHolder="0.00"
                        step="0.01"
                        draggable={false}
                        onDragStart={(e) => e.stopPropagation()}
                        onchange={(e) =>
                          handleVariantChange(
                            index,
                            "menuItem_TaxPercentage",
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td className="align-middle">
                      <FormInput
                        type="number"
                        value={variant.menuItem_SalePrice || ""}
                        placeHolder="0.00"
                        draggable={false}
                        onDragStart={(e) => e.stopPropagation()}
                        step="0.01"
                        onchange={(e) =>
                          handleVariantChange(
                            index,
                            "menuItem_SalePrice",
                            e.target.value
                          )
                        }
                        prepend={getCurrencySymbol(compCurrency)}
                      />
                    </td>
                    <td className="align-middle">
                      <FormInput
                        type="number"
                        value={variant.menuItem_DeliveryPrice || ""}
                        placeHolder="0.00"
                        step="0.01"
                        draggable={false}
                        onDragStart={(e) => e.stopPropagation()}
                        onchange={(e) =>
                          handleVariantChange(
                            index,
                            "menuItem_DeliveryPrice",
                            e.target.value
                          )
                        }
                        prepend={getCurrencySymbol(compCurrency)}
                      />
                    </td>
                    <td className="align-middle">
                      <FormInput
                        type="number"
                        value={variant.menuItem_TakeAwayPrice || ""}
                        placeHolder="0.00"
                        step="0.01"
                        draggable={false}
                        onDragStart={(e) => e.stopPropagation()}
                        onchange={(e) =>
                          handleVariantChange(
                            index,
                            "menuItem_TakeAwayPrice",
                            e.target.value
                          )
                        }
                        prepend={getCurrencySymbol(compCurrency)}
                      />
                    </td>
                    <td className="align-middle">
                      <div className="d-flex align-items-center m-2 me-3">
                        <ToggleSwitch
                          isChecked={variant.menuItem_IsDefaultVariant}
                          label="Default"
                          draggable={false}
                          onDragStart={(e) => e.stopPropagation()}
                          onToggle={() =>
                            handleVariantChange(
                              index,
                              "menuItem_IsDefaultVariant",
                              !variant.menuItem_IsDefaultVariant
                            )
                          }
                          themeColor={themeColor}
                        />
                      </div>
                    </td>
                    <td className="align-middle">
                      <div className="d-flex align-items-center m-1">
                        <button
                          className="btn btn-sm btn-outline-danger me-2"
                          onClick={() => handleRemoveVariant(index)}
                          style={{
                            borderRadius: '6px',
                            padding: '4px 8px'
                          }}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                        <i
                          className="fa fa-bars"
                          style={{
                            cursor: "grab",
                            color: themeColor,
                            fontSize: '16px'
                          }}
                        ></i>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </PanelBody>
    </Panel>
  );


  const renderSEO = () => (
    <div>
      <div className="mt-3">
        <div className="row g-3">
          <div className="col-6">
            <FormInput
              label="Title"
              type="text"
              placeHolder="Enter Title"
              name="menuItem_SEOTitle"
              value={formState.menuItem_SEOTitle}
              onchange={handleInputChange("menuItem_SEOTitle")}
            />
          </div>
          <div className="col-6">
            <FormInput
              label="URL Slug"
              type="text"
              placeHolder="Enter URL Slug"
              name="menuItem_Permalink"
              value={formState.menuItem_Permalink}
              onchange={handleInputChange("menuItem_Permalink")}
            />
          </div>
          <div className="col-6">
            <FormInput
              label="Image Description"
              type="text"
              placeHolder="Enter Image Description"
              name="menuItem_ImageAltText"
              value={formState.menuItem_ImageAltText}
              onchange={handleInputChange("menuItem_ImageAltText")}
            />
          </div>
          <div className="col-12">
            <label className="form-label fw-medium">Meta Description</label>
            <textarea
              className="form-control"
              rows={3}
              placeholder="Enter Meta Description"
              value={formState.menuItem_SEODescription}
              onChange={handleInputChange("menuItem_SEODescription")}
              style={{
                border: isDarkMode ? "1px solid #404040" : "1px solid #D9D9D9",
                background: isDarkMode ? "#2d3436" : "#F9F9F9",
                color: isDarkMode ? "#ffffff" : "#000000",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="container-fluid p-3">
      {loading && <Preloader />}
      {renderBreadcrumb()}

      {/* Basic Information Panel */}
      {renderBasicInfoPanel()}

      {/* Measurements and Pricing Panels - Show Measurements for all items, Pricing always when no variants (modifier on or off) */}
      <div className="row g-4">
        {/* Measurements Panel - Show for all non-combo items (selling and non-selling) */}
        {!IsCombo && (
          <div className={toggles.menuItem_HasVariant ? "col-12" : "col-6"}>
            {renderMeasurementsPanel()}
          </div>
        )}
        {/* Pricing Panel - Show whenever variants are disabled (both modifier on and off) */}
        {!toggles.menuItem_HasVariant && (
          <div className={IsCombo ? "col-12" : "col-6"}>
            {renderPricingPanel()}
          </div>
        )}
      </div>

      {/* Variants Panel - Only show when variants are enabled */}
      {toggles.menuItem_IsSellingProduct && toggles.menuItem_HasVariant && renderVariantsPanel()}

      {/* Reporting Category (Non-selling items only) */}
      {!toggles.menuItem_IsSellingProduct && formState.menuItem_Type !== "Combo" && (
        <div className="row g-4 mb-4">
          <div className="col-12">
            <Panel className="h-100">
              <PanelHeader
                style={{
                  backgroundColor: themeColor,
                  color: "white",
                  border: "none",
                  borderRadius: "10px 10px 0 0",
                  padding: "15px 20px",
                  fontWeight: "600",
                  fontSize: "16px",
                }}
              >
                <i className="fas fa-chart-bar me-2"></i>
                Reporting Category *
              </PanelHeader>
              <PanelBody
                style={{
                  padding: "25px",
                  backgroundColor: isDarkMode ? "#2d3436" : "#ffffff",
                  borderRadius: "0 0 10px 10px",
                  border: `1px solid ${themeColor}20`,
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-between"
                  style={{
                    padding: "12px 16px",
                    background: isDarkMode ? "#3d4447" : "#f8f9fa",
                    borderRadius: "8px",
                    border: isDarkMode
                      ? "1px solid rgba(255, 255, 255, 0.1)"
                      : "1px solid #e9ecef",
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <span
                      style={{
                        fontSize: "14px",
                        color: isDarkMode ? "#ffffff" : "#6c757d",
                        fontWeight: "500",
                      }}
                    >
                      Reporting category for this item is:{" "}
                      <strong
                        style={{
                          color: isDarkMode ? "#ffffff" : "#495057",
                          fontWeight: "600",
                        }}
                      >
                        {reportingCategory?.rootCat_Name ||
                          reportingCategory?.rC_Name ||
                          (formState.reportCat_ID ? "Loading..." : "Not selected")}
                      </strong>
                    </span>
                  </div>
                  <button
                    onClick={() => openModal("showReportingCategoryModal")}
                    style={{
                      background: "transparent",
                      border: "none",
                      borderRadius: "6px",
                      padding: "6px 8px",
                      color: themeColor,
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: "32px",
                      height: "32px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = `${themeColor}20`;
                      e.currentTarget.style.transform = "scale(1.05)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "transparent";
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                    title="Edit reporting category"
                    type="button"
                  >
                    <i className="fa fa-edit" style={{ fontSize: "14px" }}></i>
                  </button>
                </div>
              </PanelBody>
            </Panel>
          </div>
        </div>
      )}

      {/* Categories and Menus Panel - Only show Categories for non-combo items */}
      {toggles.menuItem_IsSellingProduct && formState.menuItem_Type !== "Combo" && (
        <div className="row g-4 mb-4">
          <div className="col-6">
            <Panel className="h-100">
              <PanelHeader
                style={{
                  backgroundColor: themeColor,
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px 10px 0 0',
                  padding: '15px 20px',
                  fontWeight: '600',
                  fontSize: '16px'
                }}
              >
                <i className="fas fa-tags me-2"></i>
                Categories & Classification
              </PanelHeader>
              <PanelBody
                style={{
                  padding: '25px',
                  backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                  borderRadius: '0 0 10px 10px',
                  border: `1px solid ${themeColor}20`,
                  height: '100%'
                }}
              >
                <CategorySelector
                  selectedCategories={selectors.selectedParentCategory}
                  setSelectedCategories={(updater) =>
                    setSelectors((prev) => {
                      const currentCats = prev.selectedParentCategory;
                      const newCats =
                        typeof updater === "function"
                          ? updater(currentCats)
                          : updater;
                      return { ...prev, selectedParentCategory: newCats };
                    })
                  }
                  showModal={modals.showParentCategoryModal}
                  setShowModal={(val) => val ? openModal("showParentCategoryModal") : closeAllModals()}
                  onModalSubmit={handleSelectorSubmit("selectedParentCategory")}
                  setLoading={setLoading}
                  excludeAddOnCategories={true}
                />

                {/* Reporting Category Display - Always show when categories are selected */}
                {selectors.selectedParentCategory.length > 0 && (
                  <div className="mt-4">
                    <div
                      className="d-flex align-items-center justify-content-between"
                      style={{
                        padding: "12px 16px",
                        background: isDarkMode ? "#3d4447" : "#f8f9fa",
                        borderRadius: "8px",
                        border: isDarkMode ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid #e9ecef",
                      }}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <span style={{
                          fontSize: "14px",
                          color: isDarkMode ? "#ffffff" : "#6c757d",
                          fontWeight: "500"
                        }}>
                          Reporting category for this item is:{" "}
                          <strong style={{
                            color: isDarkMode ? "#ffffff" : "#495057",
                            fontWeight: "600"
                          }}>
                            {reportingCategory?.rootCat_Name ||
                              reportingCategory?.rC_Name ||
                              (selectors.selectedParentCategory.length > 0
                                ? (selectors.selectedParentCategory[0]?.rootCat_Name || selectors.selectedParentCategory[0]?.rC_Name || "Not selected")
                                : "Not selected")}
                          </strong>
                        </span>
                      </div>
                      <button
                        onClick={() => openModal("showReportingCategoryModal")}
                        style={{
                          background: "transparent",
                          border: "none",
                          borderRadius: "6px",
                          padding: "6px 8px",
                          color: themeColor,
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          minWidth: "32px",
                          height: "32px",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = `${themeColor}20`;
                          e.currentTarget.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "transparent";
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                        title="Edit reporting category"
                      >
                        <i className="fa fa-edit" style={{ fontSize: "14px" }}></i>
                      </button>
                    </div>
                  </div>
                )}

              </PanelBody>
            </Panel>
          </div>
          <div className="col-6">
            <Panel className="h-100">
              <PanelHeader
                style={{
                  backgroundColor: themeColor,
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px 10px 0 0',
                  padding: '15px 20px',
                  fontWeight: '600',
                  fontSize: '16px'
                }}
              >
                <i className="fas fa-th-list me-2"></i>
                Menu Groups
              </PanelHeader>
              <PanelBody
                style={{
                  padding: '25px',
                  backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                  borderRadius: '0 0 10px 10px',
                  border: `1px solid ${themeColor}20`,
                  height: '100%'
                }}
              >
                <MenuGroupsSelector
                  selectedGroups={selectors.selectedMenuGroups}
                  setSelectedGroups={(groups) =>
                    setSelectors((prev) => ({
                      ...prev,
                      selectedMenuGroups: Array.isArray(groups) ? groups : [],
                    }))
                  }
                  showModal={modals.showMenuGroupModal}
                  setShowModal={(val) => val ? openModal("showMenuGroupModal") : closeAllModals()}
                  onModalSubmit={handleSelectorSubmit("selectedMenuGroups")}
                  setLoading={setLoading}
                />
              </PanelBody>
            </Panel>
          </div>
        </div>
      )}

      {/* Combo Products Panel - Only for combo products */}
      {IsCombo && (
        <Panel className="mb-4">
          <PanelHeader
            style={{
              backgroundColor: themeColor,
              color: 'white',
              border: 'none',
              borderRadius: '10px 10px 0 0',
              padding: '15px 20px',
              fontWeight: '600',
              fontSize: '16px'
            }}
          >
            <i className="fas fa-layer-group me-2"></i>
            Combo Products
          </PanelHeader>
          <PanelBody
            style={{
              padding: '25px',
              backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
              borderRadius: '0 0 10px 10px',
              border: `1px solid ${themeColor}20`
            }}
          >
            <>
              {selectors.selectedProducts.length > 0 ? (
                <div className="mt-3">
                  <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-3">
                    {selectors.selectedProducts.map((product) => (
                      <div key={product.menuItem_ID} className="col">
                        <div
                          className="product-chip"
                          style={{
                            background: isDarkMode ? "#3d4447" : "#ffffff",
                            borderRadius: "12px",
                            padding: "16px 20px",
                            border: isDarkMode ? "2px solid rgba(255, 255, 255, 0.2)" : "2px solid #e9ecef",
                            transition: "all 0.2s ease",
                            cursor: "default",
                            position: "relative",
                            boxShadow: isDarkMode ? "0 2px 8px rgba(0, 0, 0, 0.3)" : "0 2px 8px rgba(0, 0, 0, 0.05)",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.borderColor = "#007bff";
                            e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 123, 255, 0.15)";
                            e.currentTarget.style.transform = "translateY(-2px)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.borderColor = isDarkMode ? "rgba(255, 255, 255, 0.2)" : "#e9ecef";
                            e.currentTarget.style.boxShadow = isDarkMode ? "0 2px 8px rgba(0, 0, 0, 0.3)" : "0 2px 8px rgba(0, 0, 0, 0.05)";
                            e.currentTarget.style.transform = "translateY(0)";
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                              <div
                                style={{
                                  width: "36px",
                                  height: "36px",
                                  background: isDarkMode ? "#2d3436" : "#f8f9fa",
                                  borderRadius: "8px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginRight: "12px",
                                  border: isDarkMode ? "1px solid rgba(255, 255, 255, 0.2)" : "1px solid #e9ecef",
                                  overflow: "hidden",
                                }}
                              >
                                {product.menuItem_Image ? (
                                  <img
                                    src={product.menuItem_Image}
                                    alt={product.menuItem_DefaultVariantTitle ?? product.MenuItem_DefaultVariantTitle ?? product.menuItem_Name ?? product.MenuItem_Name ?? ""}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                      borderRadius: "6px",
                                    }}
                                  />
                                ) : (
                                  <i className="fa fa-box" style={{ fontSize: "14px", color: isDarkMode ? "#adb5bd" : "#6c757d" }}></i>
                                )}
                              </div>
                              <div>
                                <span style={{ fontSize: "15px", fontWeight: "500", color: isDarkMode ? "#ffffff" : "#495057" }}>
                                  {product.menuItem_DefaultVariantTitle ?? product.MenuItem_DefaultVariantTitle ?? product.menuItem_Name ?? product.MenuItem_Name ?? ""}
                                </span>
                              </div>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                              <FormInput
                                type="text"
                                value={product.availableQuantity}
                                onchange={(e) => handleProductQuantityChange(product.menuItem_ID, e.target.value)}
                                placeHolder="Qty"
                                style={{
                                  width: "60px",
                                  fontSize: "12px",
                                  padding: "4px 8px",
                                  border: isDarkMode ? "1px solid rgba(255, 255, 255, 0.2)" : "1px solid #e9ecef",
                                  borderRadius: "4px",
                                  textAlign: "center",
                                  backgroundColor: isDarkMode ? "#2d3436" : "#ffffff",
                                  color: isDarkMode ? "#ffffff" : "#000000",
                                }}
                              />
                              <button
                                onClick={() => removeProduct(product.menuItem_ID)}
                                style={{
                                  background: "transparent",
                                  border: "none",
                                  borderRadius: "6px",
                                  width: "28px",
                                  height: "28px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                  transition: "all 0.2s ease",
                                  color: "#dc3545",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.background = isDarkMode ? "rgba(220, 53, 69, 0.2)" : "#f8d7da";
                                  e.currentTarget.style.color = isDarkMode ? "#ff6b7a" : "#721c24";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.background = "transparent";
                                  e.currentTarget.style.color = "#dc3545";
                                }}
                              >
                                <i className="fa fa-times" style={{ fontSize: "12px" }}></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="d-flex justify-content-center mt-4">
                    <button
                      onClick={() => openModal("showProductModal")}
                      style={{
                        backgroundColor: themeColor,
                        background: `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`,
                        border: `1px solid ${themeColor}`,
                        boxShadow: `0 4px 15px ${themeColor}40`,
                        borderRadius: "8px",
                        padding: "10px 20px",
                        color: "white",
                        fontSize: "14px",
                        fontWeight: "500",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = `linear-gradient(135deg, ${themeColor}dd 0%, ${themeColor} 100%)`;
                        e.currentTarget.style.transform = "translateY(-1px)";
                        e.currentTarget.style.boxShadow = `0 6px 20px ${themeColor}60`;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`;
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = `0 4px 15px ${themeColor}40`;
                      }}
                    >
                      <i className="fa-solid fa-plus" style={{ fontSize: "12px" }}></i>
                      Choose Product
                    </button>
                  </div>
                </div>
              ) : (
                <div className="text-center py-4">
                  <div
                    style={{
                      width: "60px",
                      height: "60px",
                      background: "#f8f9fa",
                      borderRadius: "12px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                      border: "1px solid #e9ecef",
                    }}
                  >
                    <i className="fa fa-box" style={{ fontSize: "24px", color: "#6c757d" }}></i>
                  </div>
                  <p style={{ color: "#6c757d", fontSize: "15px", marginBottom: "20px" }}>
                    No products selected
                  </p>
                  <button
                    onClick={() => openModal("showProductModal")}
                    style={{
                      backgroundColor: themeColor,
                      background: `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`,
                      border: `1px solid ${themeColor}`,
                      boxShadow: `0 4px 15px ${themeColor}40`,
                      borderRadius: "8px",
                      padding: "10px 20px",
                      color: "white",
                      fontSize: "14px",
                      fontWeight: "500",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      margin: "0 auto",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = `linear-gradient(135deg, ${themeColor}dd 0%, ${themeColor} 100%)`;
                      e.currentTarget.style.transform = "translateY(-1px)";
                      e.currentTarget.style.boxShadow = `0 6px 20px ${themeColor}60`;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`;
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = `0 4px 15px ${themeColor}40`;
                    }}
                  >
                    <i className="fa-solid fa-plus" style={{ fontSize: "12px" }}></i>
                    Choose Product
                  </button>
                </div>
              )}
              <ProductMultiSelectionModal
                isEnabled={true}
                setIsEnabled={() => { }}
                selectedProducts={selectors.selectedProducts}
                setSelectedProducts={(products) =>
                  setSelectors((prev) => ({
                    ...prev,
                    selectedProducts: products.map((p) => ({
                      ...p,
                      availableQuantity: p.availableQuantity || "1",
                    })),
                  }))
                }
                showModal={modals.showProductModal}
                setShowModal={(val) => val ? openModal("showProductModal") : closeAllModals()}
                onModalSubmit={handleSelectorSubmit("selectedProducts")}
                setLoading={setLoading}
                products={products}
                showButton={true}
              />
            </>
          </PanelBody>
        </Panel>
      )}

      {/* Menus & Allergens Panel - Only for combo items */}
      {toggles.menuItem_IsSellingProduct && formState.menuItem_Type === "Combo" && (
        <div className="row g-4 mb-4">
          <div className="col-6">
            <Panel className="h-100">
              <PanelHeader
                style={{
                  backgroundColor: themeColor,
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px 10px 0 0',
                  padding: '15px 20px',
                  fontWeight: '600',
                  fontSize: '16px'
                }}
              >
                <i className="fas fa-th-list me-2"></i>
                Menu Groups
              </PanelHeader>
              <PanelBody
                style={{
                  padding: '25px',
                  backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                  borderRadius: '0 0 10px 10px',
                  border: `1px solid ${themeColor}20`,
                  height: '100%'
                }}
              >
                <MenuGroupsSelector
                  selectedGroups={selectors.selectedMenuGroups}
                  setSelectedGroups={(groups) =>
                    setSelectors((prev) => ({
                      ...prev,
                      selectedMenuGroups: Array.isArray(groups) ? groups : [],
                    }))
                  }
                  showModal={modals.showMenuGroupModal}
                  setShowModal={(val) => val ? openModal("showMenuGroupModal") : closeAllModals()}
                  onModalSubmit={handleSelectorSubmit("selectedMenuGroups")}
                  setLoading={setLoading}
                />
              </PanelBody>
            </Panel>
          </div>
          <div className="col-6">
            <Panel className="h-100">
              <PanelHeader
                style={{
                  backgroundColor: themeColor,
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px 10px 0 0',
                  padding: '15px 20px',
                  fontWeight: '600',
                  fontSize: '16px'
                }}
              >
                <i className="fas fa-exclamation-triangle me-2"></i>
                Allergens
              </PanelHeader>
              <PanelBody
                style={{
                  padding: '25px',
                  backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                  borderRadius: '0 0 10px 10px',
                  border: `1px solid ${themeColor}20`,
                  height: '100%'
                }}
              >
                <AllergenSelector
                  selectedAllergens={selectors.selectedAllergens}
                  setSelectedAllergens={(allergens) =>
                    setSelectors((prev) => ({
                      ...prev,
                      selectedAllergens: allergens,
                    }))
                  }
                  showModal={modals.showAllergenModal}
                  setShowModal={(val) => val ? openModal("showAllergenModal") : closeAllModals()}
                  onModalSubmit={handleSelectorSubmit("selectedAllergens")}
                  allergens={allAllergens}
                  setLoading={setLoading}
                />
              </PanelBody>
            </Panel>
          </div>
        </div>
      )}

      {/* Add-on Groups & Allergens Panel - Only for non-combo items */}
      {toggles.menuItem_IsSellingProduct && formState.menuItem_Type !== "Combo" && (
        <Panel className="mb-4">
          <PanelHeader
            style={{
              backgroundColor: themeColor,
              color: 'white',
              border: 'none',
              borderRadius: '10px 10px 0 0',
              padding: '15px 20px',
              fontWeight: '600',
              fontSize: '16px'
            }}
          >
            <i className="fas fa-list-ul me-2"></i>
            Add-on Groups & Allergens
          </PanelHeader>
          <PanelBody
            style={{
              padding: '25px',
              backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
              borderRadius: '0 0 10px 10px',
              border: `1px solid ${themeColor}20`
            }}
          >
            <div className="row g-4">
              <div className="col-md-6">
                <ModifierGroupsSelector
                  selectedGroups={selectors.selectedModifierGroups}
                  setSelectedGroups={(groups) =>
                    setSelectors((prev) => ({
                      ...prev,
                      selectedModifierGroups: Array.isArray(groups) ? groups : [],
                    }))
                  }
                  showModal={modals.showModifierModal}
                  setShowModal={(val) => val ? openModal("showModifierModal") : closeAllModals()}
                  onModalSubmit={handleSelectorSubmit("selectedModifierGroups")}
                  setLoading={setLoading}
                />
              </div>
              <div className="col-md-6">
                <AllergenSelector
                  selectedAllergens={selectors.selectedAllergens}
                  setSelectedAllergens={(allergens) =>
                    setSelectors((prev) => ({
                      ...prev,
                      selectedAllergens: allergens,
                    }))
                  }
                  showModal={modals.showAllergenModal}
                  setShowModal={(val) => val ? openModal("showAllergenModal") : closeAllModals()}
                  onModalSubmit={handleSelectorSubmit("selectedAllergens")}
                  allergens={allAllergens}
                  setLoading={setLoading}
                />
              </div>
            </div>
          </PanelBody>
        </Panel>
      )}


      {/* SEO, Product Settings, and Additional Options Panels */}
      <div className="row g-4 mb-4">
        {toggles.menuItem_IsSellingProduct && (
          <div className="col-6">
            <Panel className="h-100">
              <PanelHeader
                style={{
                  backgroundColor: themeColor,
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px 10px 0 0',
                  padding: '15px 20px',
                  fontWeight: '600',
                  fontSize: '16px'
                }}
              >
                <i className="fas fa-search me-2"></i>
                Search Ranking Improvement
              </PanelHeader>

              <PanelBody
                style={{
                  padding: '25px',
                  backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                  borderRadius: '0 0 10px 10px',
                  border: `1px solid ${themeColor}20`,
                  height: '100%'
                }}
              >
                {renderSEO()}
              </PanelBody>
            </Panel>
          </div>
        )}
      
        <div className={toggles.menuItem_IsSellingProduct ? "col-6" : "col-12"}>
          {renderAdditionalOptions()}
        </div>
      </div>

      {/* Branch Assignment Section - Only show for parent branches */}
      {isParentBranch && (
        <div className="row g-4 mb-4">
          <div className="col-12">
            <Panel>
              <PanelHeader
                style={{
                  backgroundColor: themeColor,
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px 10px 0 0',
                  padding: '15px 20px',
                  fontWeight: '600',
                  fontSize: '16px'
                }}
              >
                <i className="fas fa-code-branch me-2"></i>
                Branch Assignment
              </PanelHeader>
              <PanelBody
                style={{
                  padding: '25px',
                  backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
                  borderRadius: '0 0 10px 10px',
                  border: `1px solid ${themeColor}20`
                }}
              >
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div>
                    <h6 style={{ marginBottom: '5px', fontWeight: '600' }}>
                      Assign to Branches
                    </h6>
                    <p style={{ margin: 0, color: isDarkMode ? '#b2bec3' : '#6c757d', fontSize: '14px' }}>
                      Select which branches should have access to this product
                    </p>
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => openModal("showBranchAssignmentModal")}
                    style={{
                      backgroundColor: themeColor,
                      border: 'none',
                      borderRadius: '8px',
                      padding: '8px 16px',
                      fontSize: '14px',
                      fontWeight: '500'
                    }}
                  >
                    <i className="fas fa-edit me-2"></i>
                    Manage Branches
                  </button>
                </div>
                {selectedBranches.length > 0 ? (
                  <div style={{
                    padding: '15px',
                    backgroundColor: isDarkMode ? '#1e2124' : '#f8f9fa',
                    borderRadius: '8px',
                    border: `1px solid ${themeColor}30`
                  }}>
                    <div className="d-flex align-items-center mb-2">
                      <i className="fas fa-check-circle me-2" style={{ color: themeColor }}></i>
                      <span style={{ fontWeight: '500' }}>
                        Assigned to {selectedBranches.length} branch{selectedBranches.length !== 1 ? 'es' : ''}
                      </span>
                    </div>
                    <div className="d-flex flex-wrap gap-2 mt-2">
                      {selectedBranches.map((branch) => {
                        const branchId = typeof branch === 'number' ? branch : (branch.CompID || branch.compID || branch.branchCompID);
                        const branchName = typeof branch === 'object' 
                          ? (branch.CompName || branch.compName || branch.Comp_Name || `Branch ${branchId}`)
                          : `Branch ${branch}`;
                        return (
                          <span
                            key={branchId}
                            className="badge"
                            style={{
                              backgroundColor: `${themeColor}20`,
                              color: themeColor,
                              padding: '6px 12px',
                              fontSize: '13px',
                              fontWeight: '500'
                            }}
                          >
                            {branchName}
                          </span>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <div style={{
                    padding: '15px',
                    backgroundColor: isDarkMode ? '#1e2124' : '#f8f9fa',
                    borderRadius: '8px',
                    border: `1px dashed ${themeColor}50`,
                    textAlign: 'center',
                    color: isDarkMode ? '#b2bec3' : '#6c757d'
                  }}>
                    <i className="fas fa-info-circle me-2"></i>
                    No branches assigned yet. Click "Manage Branches" to assign this product to child branches.
                  </div>
                )}
              </PanelBody>
            </Panel>
          </div>
        </div>
      )}

      {/* <div className="row g-4 mt-2">
        {renderAdditionalFlags()}
        {renderOtherSection()}
      </div> */}

      {/* Reporting Category Modal */}
      <ReportingCategoryModel
        isModalOpen={modals.showReportingCategoryModal}
        setIsModalOpen={(val) => val ? openModal("showReportingCategoryModal") : closeAllModals()}
        onCategorySubmit={handleReportingCategorySubmit}
        compID={CompID}
        selectedCategory={reportingCategory}
        categories={allCategories}
        showButton={true}
      />

      {/* Branch Assignment Selector Modal */}
      {isParentBranch && (
        <BranchAssignmentSelector
          isOpen={modals.showBranchAssignmentModal}
          onClose={() => closeAllModals()}
          selectedBranches={selectedBranches}
          setSelectedBranches={setSelectedBranches}
          productId={null}
          parentCompID={CompID}
        />
      )}
    </div>
  );
};

export default CreateItem;
